﻿import { oBase, Ilk, oBool, oColor, oCsv, oDaton, oDatim, oDouble, oFloat, oHomin, oInt16, oInt32, oInt64, oMay, oMemo, oText, oWkd } from "../util/ovars";
import { DIALOG1 } from "../util/dialog1";
import { DIALOG2 } from "../util/dialog2";
import { DIALOG3 } from "../util/dialog3";
import { DIALOG4 } from "../util/dialog4";
import { DIALOG5 } from "../util/dialog5";
import { DIALOG20 } from "../util/dialog20";
import { DIALOG21 } from "../util/dialog21";
import { DIALOG30 } from "../util/dialog30";
import { DIALOG500 } from "../util/dialog500";



"use strict";
// TS 2026-04-01B
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

export class jsDebug {
    public static long_sleep_when_check_if_reload_needed: boolean = true;
}

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

export class NRECT {
    // הגדרת משתנים מפורשת (לא הסקה אוטומטית)

    public top: number;
    public bottom: number;
    public left: number;
    public right: number;

    constructor(p_top: number = 0, p_bottom: number = 0, p_left: number = 0, p_right: number = 0) {
        this.top = p_top;
        this.bottom = p_bottom;
        this.left = p_left;
        this.right = p_right;
    }

    public GetWidth(): number {
        const width: number = this.right - this.left;
        return width;
    }

    public GetHeight(): number {
        const height: number = this.bottom - this.top;
        return height;
    }

    public GetArea(): number {
        const width: number = this.GetWidth();
        const height: number = this.GetHeight();
        const area: number = width * height;
        return area;
    }

    public IsLeftTo(x: number): boolean {
        return x < this.left;
    }

    public IsRightTo(x: number): boolean {
        return x > this.right;
    }

    // שים לב: בקוד המקור היו שתי גרסאות ל-IsAbove. לקחתי את האחרונה שהגדרת.
    public IsAbove(y: number): boolean {
        return this.bottom <= y;
    }

    public GetStringForDebug(p_title: string): string {
        const stg: string = `${p_title}: left=${this.left} right=${this.right} top=${this.top} bottom=${this.bottom}`;
        return stg;
    }

    public GetCloneAndIncrease(size: number): NRECT {
        if (size < 0) {
            console.error("size < 0");
        }
        const temp: NRECT = new NRECT();
        temp.left = this.left - size;
        temp.right = this.right + size;
        temp.top = this.top - size;
        temp.bottom = this.bottom + size;
        return temp;
    }

    public GetCloneAndDecrease(size: number): NRECT {
        if (size < 0) {
            console.error("size < 0");
        }
        const temp: NRECT = new NRECT();
        temp.left = this.left + size;
        temp.right = this.right - size;
        temp.top = this.top + size;
        temp.bottom = this.bottom - size;
        return temp;
    }

}



//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------



//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------




export enum DefaultIfEmptyString {
    Unknown,
    Zero,
    MinusOne
}

export enum NullValueDefiner {
    NoneValue,
    Unknown,
    Zero,
    MinusOne
}

//-------------------------------------------------------------------------------------------------------
//                                  Alloy START                            
//-------------------------------------------------------------------------------------------------------



export namespace Alloy {

    // export :אם תהיה בעיה צריך לזכור שאולי צריך להוסיף כאן export שים לב: אין לנו כאן
    // export :אם תהיה בעיה צריך לזכור שאולי צריך להוסיף כאן export שים לב: אין לנו כאן
    export class BoolAndString {
        public bval: boolean;
        public strg: string;

        constructor(p_bval: boolean = false, p_str: string = "") {
            this.bval = p_bval;
            this.strg = p_str;
        }
    }

    export class BoolAndResponse {
        public bval: boolean;
        public response: string;

        constructor(p_bval: boolean = false, p_response: string = null) {
            this.bval = p_bval;
            this.response = p_response;
        }
    }

    export class PairOfNumbers {
        public num1: number;
        public num2: number;

        constructor(p_num1: number, p_num2: number) {
            this.num1 = p_num1;
            this.num2 = p_num2;
        }
    }

}


//-------------------------------------------------------------------------------------------------------
//                                  STR START
//-------------------------------------------------------------------------------------------------------

export class STR {
    public static string_is_empty_or_contains_only_whitespace_chars(p_str: string): boolean {
        for (let i: number = 0; i < p_str.length; i++) {
            // הנחה: UTL היא מחלקה סטטית אחרת שקיימת בפרויקט שלך
            if (UTL.char_is_whitespace(p_str[i]) === false) {
                return false;
            }
        }
        return true;
    }

    public static string_contains_any_non_whitespace_char(p_str: string): boolean {
        const is_empty_or_white_space: boolean = STR.string_is_empty_or_contains_only_whitespace_chars(p_str);
        const result_bool: boolean = (!is_empty_or_white_space);
        return result_bool;
    }

    public static get_copy_of_string_remove_spaces(str: string): string {
        let result = "";
        for (let i = 0; i < str.length; i++) {
            if (str[i] !== ' ') {
                result += str[i];
            }
        }
        return result;
    }

    public static cut_str_head(p_str: string, p_num_of_chars: number): string {
        return p_str.substring(p_num_of_chars);
    }

    public static cut_str_tail(p_str: string, p_num_of_chars: number): string {
        return p_str.substring(0, p_str.length - p_num_of_chars);
    }

}



//-------------------------------------------------------------------------------------------------------
//                                  GAME DIM UTILITIES
//-------------------------------------------------------------------------------------------------------




//-------------------------------------------------------------------------------------------------------
//                                  INTEGRITY START                            
//-------------------------------------------------------------------------------------------------------


export class Integrity { //xx
    public static Assert(variable: unknown, expected_type: string): void {
        if (typeof variable !== expected_type) {
            const message: string = `Integrity.Assert().\nType mismatch! Expected type: ${expected_type}, but got: ${typeof variable}`;
            alert(message);
        }
    }
}



export enum Whisper {
    UNDEFINED,
    DEFAULT,
    MB10,
    MB100,
    MB1000,
    ALIGN_CENTER,
    ALIGN_LEFT,
    ALIGN_RIGHT,
    LONG_STRING_ALIGN_TO_RIGHT,
    LONG_STRING_ALIGN_TO_LEFT
}


//-------------------------------------------------------------------------------------------------------
//                                              WHISPER END
//-------------------------------------------------------------------------------------------------------


//-------------------------------------------------------------------------------------------------------
//                                              VOICE/ECHO has been removed
//-------------------------------------------------------------------------------------------------------


//-------------------------------------------------------------------------------------------------------
//                                              DIALOGS AUX START
//-------------------------------------------------------------------------------------------------------

export class DIALOG_AUX_FUNCTIONS {

    public static fill_button_style_values(p_button_element: HTMLElement, p_text: string, p_color: string, backgroundColor: string): void {
        p_button_element.textContent = p_text;
        p_button_element.style.padding = "8px 16px";
        p_button_element.style.fontSize = "16px";
        //p_button_element.style.fontWeight = "bold";
        p_button_element.style.backgroundColor = backgroundColor;
        p_button_element.style.color = p_color;
        p_button_element.style.border = "none";
        p_button_element.style.borderRadius = "5px";
        p_button_element.style.cursor = "pointer";
        p_button_element.style.width = "95px";
        p_button_element.style.outline = "none";
    }

    public static create_close_button_element(): HTMLSpanElement {
        const closeButton = document.createElement("span");
        closeButton.textContent = "×";
        closeButton.style.fontSize = "24px";
        closeButton.style.cursor = "pointer";
        closeButton.style.position = "absolute";
        closeButton.style.top = "1px";
        closeButton.style.right = "5px";
        return closeButton;
    }

    public static create_defo_button_element(): HTMLSpanElement {
        const debugfocusButton = document.createElement("span");
        debugfocusButton.textContent = "focus";
        debugfocusButton.style.fontSize = "14px";
        debugfocusButton.style.cursor = "pointer";
        debugfocusButton.style.position = "absolute";
        debugfocusButton.style.top = "5px";
        debugfocusButton.style.left = "5px";
        debugfocusButton.style.backgroundColor = "red";
        debugfocusButton.style.height = "16px";
        debugfocusButton.style.padding = "0px";
        return debugfocusButton;
    }

    public static create_ok_button_element(): HTMLButtonElement {
        const element = document.createElement("button");
        DIALOG_AUX_FUNCTIONS.fill_button_style_values(element, "Ok", "black", "#4CAF50");
        return element;
    }

    public static create_cancel_button_element(): HTMLButtonElement {
        const element = document.createElement("button");
        DIALOG_AUX_FUNCTIONS.fill_button_style_values(element, "Cancel", "black", "#f44336");
        return element;
    }

    public static create_erase_button_element(): HTMLButtonElement {
        const element = document.createElement("button");
        DIALOG_AUX_FUNCTIONS.fill_button_style_values(element, "Erase", "black", "yellow");
        return element;
    }

    public static get_caption_backgroundColor(): string {
        return "blue";
    }

    public static get_caption_forgroundColor(): string {
        return "white";
    }

    public static get_panel_backgroundColor(): string {
        return "cyan";
    }

    public static put_pseudo_focus_indcator(p_button_element: HTMLElement, focus_indicator_flag: boolean): void {
        if (focus_indicator_flag == true) {
            p_button_element.style.border = '6px solid black';
        }
        if (focus_indicator_flag == false) {
            p_button_element.style.border = 'none';
        }
    }
}

//-------------------------------------------------------------------------------------------------------
//                                              DIALOGS AUX SEND
//-------------------------------------------------------------------------------------------------------




export enum Elcon {
    textContent,
    innerHTML
}


//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------





//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

export class GSP {
    // InputDialog
    public static InputDialogAsync_p_OBJ: oBase = null;
    public static InputDialogAsync_p_whisper: Whisper = null;
    public static InputDialogAsync_resolve_function_pointer: Function = null; // ומשתנה זה רק שומר מצביע אליה executor_function כדי להזכיר שזאת לא פונקציה שלנו אלא פונקציה שקיבלנו מאת ה "_pointer" הוספנו את המילה
    public static SportAsync_p_OBJ: oBase = null;
    public static SportAsync_p_catlist: Catlist = null;
    public static SportAsync_resolve_function_pointer: Function = null; // ומשתנה זה רק שומר מצביע אליה executor_function כדי להזכיר שזאת לא פונקציה שלנו אלא פונקציה שקיבלנו מאת ה "_pointer" הוספנו את המילה

    
    public static InputDialogWithCallback(p_OBJ: oBase, p_callback_function: Function, p_whisper: Whisper): void {
        const CONSTRUCTOR = Object.getPrototypeOf(p_OBJ).constructor;
        if (CONSTRUCTOR === oBool) {
            DIALOG4.create_dialog(p_callback_function, p_OBJ as oBool, p_whisper);
        }
        if (CONSTRUCTOR === oColor) {
            alert("oColor");
        }
        if (CONSTRUCTOR === oCsv) {
            alert("oCsv");
        }
        if (CONSTRUCTOR === oDatim) {
            alert("oDatim");
        }
        if (CONSTRUCTOR === oDaton) {
            DIALOG3.create_dialog(p_callback_function, p_OBJ as oDaton, p_whisper);
        }
        if (CONSTRUCTOR === oDouble) {
            alert("oDouble");
        }
        if (CONSTRUCTOR === oFloat) {
            alert("oFloat");
        }
        if (CONSTRUCTOR === oHomin) {
            DIALOG5.create_dialog(p_callback_function, p_OBJ as oHomin, p_whisper);
        }
        if (CONSTRUCTOR === oInt16) {
            DIALOG1.create_dialog(p_callback_function, p_OBJ as oInt16, p_whisper);
        }
        if (CONSTRUCTOR === oInt32) {
            DIALOG1.create_dialog(p_callback_function, p_OBJ as oInt32, p_whisper);
        }
        if (CONSTRUCTOR === oInt64) {
            DIALOG1.create_dialog(p_callback_function, p_OBJ as oInt64, p_whisper);
        }
        if (CONSTRUCTOR === oMay) {
            alert("oMay");
        }
        if (CONSTRUCTOR === oMemo) {
            // oMemo – in the future may create a specific dialog for DIALOG2; for now we use it
            DIALOG2.create_dialog(p_callback_function, p_OBJ as oMemo, p_whisper);
        }
        if (CONSTRUCTOR === oText) {
            DIALOG2.create_dialog(p_callback_function, p_OBJ as oText, p_whisper);
        }
        if (CONSTRUCTOR === oWkd) {
            alert("oWkd");
        }
    }
    //MMMM






    // InputDialog Async

    public static InputDialogAsync_callback(p_changed_flag: boolean, p_OBJ: oBase): void {
        if (typeof GSP.InputDialogAsync_resolve_function_pointer !== "function") {
            alert("internal error");
        }

        // !!! Update the object value
        Object.assign(GSP.InputDialogAsync_p_OBJ, p_OBJ);

        UTL.block_everything = false;
        UTL.modal_is_opened = false;

        GSP.InputDialogAsync_resolve_function_pointer!(p_changed_flag);
    }

    public static InputDialogAsync_executor_functionx(p_resolve: Function, p_reject: Function): void {
        GSP.InputDialogAsync_resolve_function_pointer = p_resolve;
        const p_OBJ = GSP.InputDialogAsync_p_OBJ;
        const p_whisper = GSP.InputDialogAsync_p_whisper;
        GSP.InputDialogWithCallback(p_OBJ, GSP.InputDialogAsync_callback, p_whisper);
    }


    public static InputDialogAsync_executor_function(p_resolve: Function, p_reject: Function): void {
        // assign resolve to the public static field
        if (false) {
            alert("executor_function");
        }
        GSP.InputDialogAsync_resolve_function_pointer = p_resolve;

        // get the current objects
        const p_OBJ = GSP.InputDialogAsync_p_OBJ;
        const p_whisper = GSP.InputDialogAsync_p_whisper;

        // call the normal callback function
        GSP.InputDialogWithCallback(p_OBJ, GSP.InputDialogAsync_callback, p_whisper);
    }












    public static InputDialogAsync(p_OBJ: oBase, p_whisper: Whisper): Promise<boolean> {
        UTL.block_everything = true;
        UTL.modal_is_opened = true;

        GSP.InputDialogAsync_p_OBJ = p_OBJ;
        GSP.InputDialogAsync_p_whisper = p_whisper;

        return new Promise(GSP.InputDialogAsync_executor_function);
    }

    // Sport
    public static SportWithCallback(p_OBJ: oBase, p_callback_function: Function, catlist: Catlist): void {
        DIALOG30.create_dialog(p_callback_function, p_OBJ, catlist);
    }


    public static SportAsync_callback(p_changed_flag: boolean, p_OBJ: oBase): void {
        if (typeof GSP.SportAsync_resolve_function_pointer !== "function") {
            alert("internal error");
        }

        Object.assign(GSP.SportAsync_p_OBJ, p_OBJ);

        UTL.block_everything = false;
        UTL.modal_is_opened = false;

        GSP.SportAsync_resolve_function_pointer!(p_changed_flag);
    }

    public static SportAsync_executor_function(p_resolve: Function, p_reject: Function): void {
        GSP.SportAsync_resolve_function_pointer = p_resolve;
        const p_OBJ = GSP.SportAsync_p_OBJ;
        const p_catlist = GSP.SportAsync_p_catlist;
        GSP.SportWithCallback(p_OBJ, GSP.SportAsync_callback, p_catlist);
    }

    public static SportAsync(p_OBJ: oBase, p_catlist: Catlist): Promise<boolean> {
        UTL.block_everything = true;
        UTL.modal_is_opened = true;

        GSP.SportAsync_p_OBJ = p_OBJ;
        GSP.SportAsync_p_catlist = p_catlist;

        return new Promise(GSP.SportAsync_executor_function);
    }
}

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------


// --- DLG class ---
export class DLG {
    // --- HConfirmAsync ---
    public static HConfirmAsync_p_info: VECTOR_Info = null;
    public static HConfirmAsync_p_message: string = null;
    public static HConfirmAsync_resolve_function_pointer: Function = null; // ומשתנה זה רק שומר מצביע אליה executor_function כדי להזכיר שזאת לא פונקציה שלנו אלא פונקציה שקיבלנו מאת ה "_pointer" הוספנו את המילה

    public static HConfirmAsync_callback(p_changed_flag: boolean) {
        if (typeof DLG.HConfirmAsync_resolve_function_pointer !== "function") {
            alert("internal error");
            return;
        }
        UTL.block_everything = false;
        UTL.modal_is_opened = false;
        DLG.HConfirmAsync_resolve_function_pointer(p_changed_flag);
    }

    public static HConfirmAsync_executor_function(p_resolve: Function, p_reject: Function) {
        DLG.HConfirmAsync_resolve_function_pointer = p_resolve;
        DIALOG20.create_dialog(DLG.HConfirmAsync_callback, DLG.HConfirmAsync_p_info, DLG.HConfirmAsync_p_message);
    }

    public static HConfirmAsync(p_message: string): Promise<boolean> {
        UTL.block_everything = true;
        UTL.modal_is_opened = true;
        const p_info: VECTOR_Info = null;
        DLG.HConfirmAsync_p_info = p_info;
        DLG.HConfirmAsync_p_message = p_message;
        return new Promise(DLG.HConfirmAsync_executor_function);
    }

    // --- HPromptfAsync ---
    public static HPromptfAsync_p_message: string = null;
    public static HPromptfAsync_resolve_function_pointer: Function = null; // ומשתנה זה רק שומר מצביע אליה executor_function כדי להזכיר שזאת לא פונקציה שלנו אלא פונקציה שקיבלנו מאת ה "_pointer" הוספנו את המילה

    public static HPromptfAsync_callback() {
        if (typeof DLG.HPromptfAsync_resolve_function_pointer !== "function") {
            alert("internal error");
            return;
        }
        UTL.block_everything = false;
        UTL.modal_is_opened = false;
        DLG.HPromptfAsync_resolve_function_pointer();
    }

    public static HPromptfAsync_executor_function(p_resolve: Function, p_reject: Function) {
        DLG.HPromptfAsync_resolve_function_pointer = p_resolve;
        DIALOG21.create_dialog(DLG.HPromptfAsync_callback, DLG.HPromptfAsync_p_message);
    }

    public static HPromptfAsync(p_message: string): Promise<boolean> {
        debugger;
        UTL.block_everything = true;
        UTL.modal_is_opened = true;
        DLG.HPromptfAsync_p_message = p_message;
        return new Promise(DLG.HPromptfAsync_executor_function);
    }
}

//-------------------------------------------------------------------------------------------------------
//                                            TIMING START                            
//-------------------------------------------------------------------------------------------------------


export class TIMING {
    public static TodayIsAfter(mday: number, month: number, year: number): boolean {
        const daton_from_parameters = UTL.MAKE_DATON(mday, month, year);
        const today_daton = TRANS.trans_now_to_daton();
        if (today_daton > daton_from_parameters) {
            return true;
        } else {
            return false;
        }
    }
}



//-------------------------------------------------------------------------------------------------------
//                                            TableObject
//-------------------------------------------------------------------------------------------------------




export class TableObject {
    public table_element: HTMLTableElement = null;
    public taco_element: HTMLElement = null; // TAble COntainer

    public has_vertical_scroll: boolean;
    public has_horizontal_scroll: boolean;

    public exist_head: boolean;
    public exist_numerator: boolean;
    public direction: string;

    constructor() {
        // אתחול הערכים כפי שהופיעו ב-Constructor המקורי
        this.table_element = null;
        this.taco_element = null;

        this.has_vertical_scroll = false;
        this.has_horizontal_scroll = false;

        this.exist_head = false;
        this.exist_numerator = false;
        this.direction = "ltr";
    }
}



//-------------------------------------------------------------------------------------------------------
//                                            TBLSCROLLER
//-------------------------------------------------------------------------------------------------------


export class TBLSCROLLER {

    public static get_H_BIAS(table_obj: TableObject): number {
        const H_BIAS: number = table_obj.taco_element.scrollLeft;
        return H_BIAS;
    }

    public static get_V_BIAS(table_obj: TableObject): number {
        const V_BIAS: number = table_obj.taco_element.scrollTop;
        return V_BIAS;
    }

    public static set_H_IBAS(table_obj: TableObject, p_h_bias: number): void {
        table_obj.taco_element.scrollLeft = p_h_bias;
    }

    public static set_V_BIAS(table_obj: TableObject, p_v_bias: number): void {
        table_obj.taco_element.scrollTop = p_v_bias;
    }

    public static trans_cell_element_to_offsets_rect_basic(table_obj: TableObject, row_number: number, column_number: number): NRECT {
        const cell_element: HTMLElement = TABLE.trans_table_element_and_row_number_and_column_number_to_cell_element(table_obj.table_element, row_number, column_number);
        const offset_rect: NRECT = new NRECT();
        offset_rect.top = cell_element.offsetTop;
        offset_rect.left = cell_element.offsetLeft;
        offset_rect.bottom = offset_rect.top + cell_element.offsetHeight;
        offset_rect.right = offset_rect.left + cell_element.offsetWidth;
        return offset_rect;
    }

    public static trans_cell_element_to_offsets_rect_ext(table_obj: TableObject, row_number: number, column_number: number): NRECT {
        const offsets_rect: NRECT = TBLSCROLLER.trans_cell_element_to_offsets_rect_basic(table_obj, row_number, column_number);
        const cell_0_0_element: HTMLElement = TABLE.trans_table_element_and_row_number_and_column_number_to_cell_element(table_obj.table_element, 0, 0);
        let offsets_rect_ext: NRECT = new NRECT();

        if (table_obj.exist_head == false) {
            offsets_rect_ext.top = offsets_rect.top;
            offsets_rect_ext.bottom = offsets_rect.bottom;
        }
        if (table_obj.exist_head == true) {
            offsets_rect_ext.top = offsets_rect.top - cell_0_0_element.offsetTop;
            offsets_rect_ext.bottom = offsets_rect.bottom - cell_0_0_element.offsetTop;
        }
        if (table_obj.exist_numerator == false) {
            offsets_rect_ext.left = offsets_rect.left;
            offsets_rect_ext.right = offsets_rect.right;
        }
        if (table_obj.exist_numerator == true) {
            if (table_obj.direction == "ltr") {
                offsets_rect_ext.left = offsets_rect.left - cell_0_0_element.offsetLeft;
                offsets_rect_ext.right = offsets_rect.right - cell_0_0_element.offsetLeft;
            }
        }
        return offsets_rect_ext;
    }

    public static trans_offset_x_ext_to_client_x(table_obj: TableObject, offset_x_ext: number): number {
        const H_BIAS: number = TBLSCROLLER.get_H_BIAS(table_obj);
        const client_x: number = offset_x_ext - H_BIAS;
        return client_x;
    }

    public static trans_offset_y_ext_to_client_y(table_obj: TableObject, offset_y_ext: number): number {
        const V_BIAS: number = TBLSCROLLER.get_V_BIAS(table_obj);
        const client_y: number = offset_y_ext - V_BIAS;
        return client_y;
    }

    public static trans_cell_element_to_rect_ict(table_obj: TableObject, row_number: number, column_number: number): NRECT {
        const offsets_rect_ext: NRECT = TBLSCROLLER.trans_cell_element_to_offsets_rect_ext(table_obj, row_number, column_number);
        const client_rect: NRECT = new NRECT();
        client_rect.left = TBLSCROLLER.trans_offset_x_ext_to_client_x(table_obj, offsets_rect_ext.left);
        client_rect.right = TBLSCROLLER.trans_offset_x_ext_to_client_x(table_obj, offsets_rect_ext.right);
        client_rect.top = TBLSCROLLER.trans_offset_y_ext_to_client_y(table_obj, offsets_rect_ext.top);
        client_rect.bottom = TBLSCROLLER.trans_offset_y_ext_to_client_y(table_obj, offsets_rect_ext.bottom);
        return client_rect;
    }

    public static trans_row_number_to_offsetTop(table_obj: TableObject, row_number: number): number {
        const row_element: HTMLElement = TABLE.trans_table_element_and_row_number_to_row_element(table_obj.table_element, row_number);
        return row_element.offsetTop;
    }

    public static trans_column_number_to_offsetLeft(table_obj: TableObject, column: number): void {
    }

    public static calc_client_width(table_obj: TableObject): number {
        const taco_element: HTMLElement = table_obj.taco_element;
        return taco_element.clientWidth;
    }

    public static calc_client_height(table_obj: TableObject): number {
        const taco_element: HTMLElement = table_obj.taco_element;
        const row_0_REAL_OFFSET: number = TBLSCROLLER.trans_row_number_to_offsetTop(table_obj, 0);
        const virtual_height: number = taco_element.clientHeight - row_0_REAL_OFFSET;
        return virtual_height;
    }

    public static calc_client_rect(table_obj: TableObject): NRECT {
        const virtual_client_rect: NRECT = new NRECT();
        virtual_client_rect.left = 0;
        virtual_client_rect.top = 0;
        virtual_client_rect.right = TBLSCROLLER.calc_client_width(table_obj);
        virtual_client_rect.bottom = TBLSCROLLER.calc_client_height(table_obj);
        return virtual_client_rect;
    }

    public static scroll_to_cell_INA(table_obj: TableObject, row: number, column: number): void {
        const current_H_BIAS: number = TBLSCROLLER.get_H_BIAS(table_obj);
        const current_V_BIAS: number = TBLSCROLLER.get_V_BIAS(table_obj);
        const client_rect: NRECT = TBLSCROLLER.calc_client_rect(table_obj);
        const cell_rct_ict: NRECT = TBLSCROLLER.trans_cell_element_to_rect_ict(table_obj, row, column);

        if (table_obj.has_vertical_scroll == true) {
            if (UTL.y_is_above_rect(cell_rct_ict.top, client_rect) == true) {
                const delta_y: number = cell_rct_ict.top - client_rect.top;
                const new_V_BIAS: number = current_V_BIAS + delta_y;
                TBLSCROLLER.set_V_BIAS(table_obj, new_V_BIAS);
            }
            if (UTL.y_is_bellow_rect(cell_rct_ict.bottom, client_rect) == true) {
                const delta_y: number = cell_rct_ict.bottom - client_rect.bottom;
                const new_V_BIAS: number = current_V_BIAS + delta_y;
                TBLSCROLLER.set_V_BIAS(table_obj, new_V_BIAS);
            }
        }
        if (table_obj.has_horizontal_scroll == true) {
            if (UTL.x_is_left_to_rect(cell_rct_ict.left, client_rect) == true) {
                const delta_x: number = cell_rct_ict.left - client_rect.left;
                const new_H_BIAS: number = current_H_BIAS + delta_x;
                TBLSCROLLER.set_H_IBAS(table_obj, new_H_BIAS);
            }
            if (UTL.x_is_right_to_rect(cell_rct_ict.right, client_rect) == true) {
                const delta_x: number = cell_rct_ict.right - client_rect.right;
                const new_H_BIAS: number = current_H_BIAS + delta_x;
                TBLSCROLLER.set_H_IBAS(table_obj, new_H_BIAS);
            }
        }
    }
}

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------



export class CatlistRecord {
    public code: number;
    public text: string;

    constructor() {
        this.code = -1;
        this.text = "";
    }
}

export class Catlist {
    public ARR: CatlistRecord[];
    public DICT: Map<number, number>;

    constructor() {
        this.ARR = [];
        this.ARR.length = 0;
        this.DICT = new Map<number, number>();
        this.DICT.clear();
    }

    public Clear(): void {
        this.ARR.length = 0;
        this.DICT.clear();
    }

    public GetCount(): number {
        const count: number = this.ARR.length;
        return count;
    }

    public GetRecordReference(p_index: number): CatlistRecord {
        const pt: CatlistRecord = this.ARR[p_index];
        return pt;
    }

    public Append(p_code: number, p_text: string): void {
        const new_index: number = this.ARR.length;
        const rec: CatlistRecord = new CatlistRecord();
        rec.code = p_code;
        rec.text = p_text;
        this.ARR.push(rec);
        this.DICT.set(p_code, new_index);
    }

    public quick_trans_code_to_index(p_code: number): number {
        const index: number | undefined = this.DICT.get(p_code);
        if (index !== undefined) {
            return index;
        } else {
            return -1;
        }
    }

    public quick_trans_code_to_text(p_code: number): string | null {
        const index: number = this.quick_trans_code_to_index(p_code);
        if (index === -1) {
            return null;
        }
        const ipt: CatlistRecord = this.GetRecordReference(index);
        return ipt.text;
    }

    public quick_trans_code_as_str_to_text(p_code_as_str: string): string | null {
        const code_as_int: number = parseInt(p_code_as_str, 10);
        const result_txt: string | null = this.quick_trans_code_to_text(code_as_int);
        return result_txt;
    }
}
//-----------------------------------------------------------------------------------------












//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------


//-------------------------------------------------------------------------------------------------
// עצמו html  מהסיבה שאנחנו מאחסנים את המידע הזה בתוך ה htmlManager בתאריך 27.7.26 אנחנו מורידים את
//                                            <th data-fid=¨ROWNUM¨>ROWNUM</th> :ראה את הדוגמה הבאה
//-------------------------------------------------------------------------------------------------
// עצמו html  מהסיבה שאנחנו מאחסנים את המידע הזה בתוך ה htmlManager בתאריך 27.7.26 אנחנו מורידים את
//                                            <th data-fid=¨ROWNUM¨>ROWNUM</th> :ראה את הדוגמה הבאה
//-------------------------------------------------------------------------------------------------
// עצמו html  מהסיבה שאנחנו מאחסנים את המידע הזה בתוך ה htmlManager בתאריך 27.7.26 אנחנו מורידים את
//                                            <th data-fid=¨ROWNUM¨>ROWNUM</th> :ראה את הדוגמה הבאה
//-------------------------------------------------------------------------------------------------
// עצמו html  מהסיבה שאנחנו מאחסנים את המידע הזה בתוך ה htmlManager בתאריך 27.7.26 אנחנו מורידים את
//                                            <th data-fid=¨ROWNUM¨>ROWNUM</th> :ראה את הדוגמה הבאה
//-------------------------------------------------------------------------------------------------
// עצמו html  מהסיבה שאנחנו מאחסנים את המידע הזה בתוך ה htmlManager בתאריך 27.7.26 אנחנו מורידים את
//                                            <th data-fid=¨ROWNUM¨>ROWNUM</th> :ראה את הדוגמה הבאה
//-------------------------------------------------------------------------------------------------



/*
export class htmlManagerRecord {
    // מחלקה זו לא קיימת במקור ב-JS
    public fid: number = (-1);
}

export class htmlManager {
    private ARR: htmlManagerRecord[];

    public constructor() {
        this.ARR = [];
    }

    public clear(): void {
        this.ARR.length = 0;
    }

    public AddField(p_fid: number): void {
        const rec = new htmlManagerRecord();
        rec.fid = p_fid;

        // kept from original logic
        const freezed_column_number = this.ARR.length;

        this.ARR.push(rec);
    }

    public GetRecordReference(index: number): htmlManagerRecord | undefined {
        return this.ARR[index];
    }

    public slow_trans_fid_to_column_number(p_fid: number): number {
        for (let column_number = 0; column_number < this.ARR.length; column_number++) {
            const ipt = this.GetRecordReference(column_number);
            // Check if ipt exists before accessing .fid
            if (ipt && ipt.fid === p_fid) {
                return column_number;
            }
        }
        return -1;
    }

    public trans_column_number_to_fid(p_column_number: number): number {
        const index = p_column_number;
        if (index >= 0 && index < this.ARR.length) {
            const ipt = this.GetRecordReference(index);
            return ipt ? ipt.fid : -1;
        } else {
            return -1;
        }
    }

    public GetNofColumns(): number {
        return this.ARR.length;
    }
}
*/
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------


export class TRANS {
    //------------------------------------------------------------------------------------------------------------------
    //CHUNK1-START
    public static trans_DOM_element_to_info_str(title_str: string, p_el: Element): string {
        if (p_el == null) {
            return "null encountered";
        }

        let message = "";
        // title should contain its own new lines
        // title should contain its own new lines
        // title should contain its own new lines
        message += title_str; // title should contains its new lines
        // title should contain its own new lines
        // title should contain its own new lines
        message += `Tag Name: ${p_el.tagName}\n`;
        message += `ID: ${p_el.id || "(no id)"}\n`;
        message += `Class: ${p_el.className || "(no class)"}\n`;

        if ('value' in p_el) {
            message += `Value: ${p_el.value}\n`;
        }

        const text = p_el.textContent?.trim();
        if (text) {
            message += `Text Content: ${text}\n`;
        }

        const parent = p_el.parentElement;
        if (parent) {
            message += `\nParent Element Info:\n`;
            message += `Tag Name: ${parent.tagName}\n`;
            message += `ID: ${parent.id || "(no id)"}\n`;
            message += `Class: ${parent.className || "(no class)"}\n`;

            const parentText = parent.textContent?.trim();
            if (parentText) {
                message += `Text Content: ${parentText}\n`;
            }
        } else {
            message += `\nParent: None (possibly document root)\n`;
        }

        const children = p_el.children;
        if (children.length > 0) {
            message += `\nChildren:\n`;
            for (let i = 0; i < children.length; i++) {
                const child = children[i];
                message += `  - ${child.tagName} (id: ${child.id || "none"}, class: ${child.className || "none"})\n`;
            }
        } else {
            message += `\nChildren: None\n`;
        }

        return message;
    }


    public static trans_digit_string_to_digit_number(digit_as_str: string): number {
        const num = parseInt(digit_as_str);
        if (isNaN(num) == true) {
            return (-1);
        }
        if (0 <= num && num <= 9) {
            return num;
        }
        //-------------------------------

        return (-1);
    }

    public static trans_digit_number_to_string(digit_as_number: number): string {
        const digit_as_string = digit_as_number.toString();
        return digit_as_string;
    }


    public static trans_number_and_position_to_digit_as_int(number: number, position: number): number {
        const num_as_string = number.toString();
        const str_length = num_as_string.length;
        if (position > (str_length - 1)) {
            // הוא מחוץ למחרוזת position כלומר שה
            return 0;
        }

        const index = (num_as_string.length - 1) - position; // thus position=0 => index = (str.length - 1)
        const chr = num_as_string[index];
        const digit = parseInt(chr);
        return digit;
    }

    public static trans_string_to_int(p_str: string): number {
        if (p_str == "") {
            return 0;
        }
        const num = parseInt(p_str);
        // we can also use: let valueNumber = Number(valueString);
        return num;
    }


    public static trans_string_to_number(p_str: string): number {
        // באופן כללי number אלא ל int שים לב: פונקציה זו אינה מתרגמת ל
        // באופן כללי number אלא ל int שים לב: פונקציה זו אינה מתרגמת ל
        // באופן כללי number אלא ל int שים לב: פונקציה זו אינה מתרגמת ל
        // באופן כללי number אלא ל int שים לב: פונקציה זו אינה מתרגמת ל
        // trans_string_to_int() :יש להשתמש ב int אם ברצונך לתרגם ל
        // trans_string_to_int() :יש להשתמש ב int אם ברצונך לתרגם ל
        // trans_string_to_int() :יש להשתמש ב int אם ברצונך לתרגם ל
        // trans_string_to_int() :יש להשתמש ב int אם ברצונך לתרגם ל
        const num = Number(p_str);
        return num;
    }


    //CHUNK1-END
    //------------------------------------------------------------------------------------------------------------------
    //CHUNK2-START
    public static trans_string_to_int_return_minus_one_if_empty(p_str: string): number {
        if (p_str == "") {
            return (-1);
        }
        if (UTL.string_contains_int(p_str) == false) {
            alert("TABLE.trans_string_to_int_return_minus_one_if_empty().error in string");
            return (-1);
        }
        const result = parseInt(p_str, 10);
        return result;
    }





    public static trans_super_astute_string_to_int(p_str: string, defIfEmpty: DefaultIfEmptyString): number {
        if (p_str == "") {
            const result_if_empty = TRANS.trans_DefaultIfEmptyString_to_int(defIfEmpty);
            return result_if_empty;
        }
        const result = parseInt(p_str, 10);
        return result;
    }


    public static trans_int_to_string_return_empty_string_if_minus_one(p_num: number): string {
        if (p_num != (-1)) {
            return p_num.toString();
        }
        else {
            return "";
        }
    }

    public static trans_DefaultIfEmptyString_to_int(def_enum: DefaultIfEmptyString): number {
        // פונקציה זו עברה שינוי גדול בתאריך 3.4.2026
        // פונקציה זו עברה שינוי גדול בתאריך 3.4.2026
        // פונקציה זו עברה שינוי גדול בתאריך 3.4.2026
        if (def_enum == DefaultIfEmptyString.Unknown) {
            return 0; // חייבים להחזיר משהו
        }
        if (def_enum == DefaultIfEmptyString.Zero) {
            return 0;
        }
        if (def_enum == DefaultIfEmptyString.MinusOne) {
            return (-1);
        }
        return (-1);// חייבים להחזיר משהו
    }


    public static trans_NullValueDefiner_to_int(def_enum: NullValueDefiner): number {

        // פונקציה זו עברה שינוי גדול בתאריך 3.4.2026
        // פונקציה זו עברה שינוי גדול בתאריך 3.4.2026
        // פונקציה זו עברה שינוי גדול בתאריך 3.4.2026
        if (def_enum == NullValueDefiner.NoneValue) {
            return 0; // חייבים להחזיר משהו
        }
        if (def_enum == NullValueDefiner.Unknown) {
            return 0; // חייבים להחזיר משהו
        }
        if (def_enum == NullValueDefiner.Zero) {
            return 0;
        }
        if (def_enum == NullValueDefiner.MinusOne) {
            return (-1);
        }
        return 0;
    }




    public static trans_string_to_bool(p_str: string, df_unused_for_now: DefaultIfEmptyString): boolean {
        // dont use this function. use instead: trans_string_to_boolean()
        // dont use this function. use instead: trans_string_to_boolean()
        // dont use this function. use instead: trans_string_to_boolean()
        if (p_str == undefined || p_str == null) {
            alert("TRANS.trans_string_to_bool().p_str is undefined or null");
            return false;
        }
        const lcstr = TRANS.trans_string_to_lower_case(p_str); // lcstr = Lower Case STR
        if (lcstr == "false" || lcstr == "לא") {
            return false;
        }
        if (lcstr == "true" || lcstr == "כן") {
            return true;
        }

        //---------------
        return false;
    }

    public static trans_string_to_boolean(p_str: string): boolean {
        if (p_str == undefined || p_str == null) {
            alert("TRANS.trans_string_to_bool().p_str is undefined or null");
            return false;
        }
        const lcstr = TRANS.trans_string_to_lower_case(p_str); // lcstr = Lower Case STR
        if (lcstr == "false" || lcstr == "לא") {
            return false;
        }
        if (lcstr == "true" || lcstr == "כן") {
            return true;
        }

        //---------------
        return false;
    }


    public static trans_string_to_string(p_str: string): string {
        // פונקציה זו אינה עושה דבר אלא מחזירה את הפרמטר שלה
        // המטרה כאן שלפעמים זה עוזר להבין את ההקשר באמצעות השימוש בפונקציה זו
        return p_str;
    }

    public static trans_daton_string_to_daton_int_v1(p_str: string): number {
        // 13/12/2011
        if (p_str == "") {
            return (-1);
        }
        const parts = p_str.split("/");
        const mday = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);
        const daton = UTL.MAKE_DATON(mday, month, year);
        return daton;
    }

    public static trans_daton_int_to_daton_string_v1(p_daton: number): string {
        // 13/12/2011

        if (p_daton == (-1)) {
            return "";
        }

        const mday = UTL.GET_DATON_MDAY(p_daton);
        const month = UTL.GET_DATON_MONTH(p_daton);
        const year = UTL.GET_DATON_YEAR(p_daton);

        const mday_str = UTL.zoo(mday, 2);
        const month_str = UTL.zoo(month, 2);
        const year_str = UTL.zoo(year, 4);
        const result_str = `${mday_str}/${month_str}/${year_str}`;
        return result_str;
    }
    //CHUNK2-END
    //------------------------------------------------------------------------------------------------------------------
    //CHUNK3-START
    public static trans_homin_string_to_homin_int_v1(p_str: string): number {
        if (p_str == "") {
            return (-1);
        }
        const parts = p_str.split(":");
        const hour = parseInt(parts[0], 10);
        const min = parseInt(parts[1], 10);
        const homin = UTL.MAKE_HOMIN(hour, min);
        return homin;
    }

    public static trans_homin_int_to_homin_string_v1(p_homin: number): string {
        // 13/12/2011

        if (p_homin == (-1)) {
            return "";
        }

        const hour = UTL.GET_HOMIN_HOUR(p_homin);
        const min = UTL.GET_HOMIN_MIN(p_homin);

        const hour_str = UTL.zoo(hour, 2);
        const min_str = UTL.zoo(min, 2);

        const result_str = `${hour_str}:${min_str}`;
        return result_str;
    }


    public static trans_bool_to_xml_str(p_value_exit: boolean, p_value_content: boolean): string {
        // 13/12/2011

        if (p_value_exit == false) {
            return "";
        }
        if (p_value_content == true) {
            return "true";
        }
        else {
            return "false";
        }
    }

    public static trans_bool_to_cell_str_v1(p_value_exit: boolean, p_value_content: boolean): string {
        // 13/12/2011   

        if (p_value_exit == false) {
            return "";
        }
        if (p_value_content == true) {
            return "True*";
        }
        else {
            return "False*";
        }
    }

    public static trans_daton_to_xml_str(p_value_exit: boolean, p_value_content: number): string {
        if (p_value_exit == false) {
            return "";
        }
        const stg = p_value_content.toString();
        return stg;
    }

    public static trans_daton_to_cell_str_v1(p_value_exit: boolean, p_value_content: number): string {
        if (p_value_exit == false) {
            return "";
        }
        const stg = TRANS.trans_daton_int_to_daton_string_v1(p_value_content);
        return stg;
    }

    public static trans_homin_to_xml_str(p_value_exit: boolean, p_value_content: number): string {
        if (p_value_exit == false) {
            return "";
        }
        const stg = p_value_content.toString();
        return stg;
    }

    public static trans_homin_to_cell_str_v1(p_value_exit: boolean, p_value_content: number): string {
        if (p_value_exit == false) {
            return "";
        }
        const stg = TRANS.trans_homin_int_to_homin_string_v1(p_value_content);
        return stg;
    }


    public static trans_text_to_xml_str(p_value_exit: boolean, p_value_content: string): string {
        if (p_value_exit == false) {
            return "";
        }
        return p_value_content;
    }

    public static trans_text_to_cell_str_v1(p_value_exit: boolean, p_value_content: string): string {
        if (p_value_exit == false) {
            return "";
        }
        return p_value_content;
    }    //CHUNK3-END
    //------------------------------------------------------------------------------------------------------------------
    //CHUNK4-START
    public static trans_int_to_xml_str(p_value_exit: boolean, p_value_content: number): string {
        if (p_value_exit == false) {
            return "";
        }
        const stg = p_value_content.toString();
        return stg;
    }

    public static trans_daton_to_oDaton(p_daton: number): oDaton {
        if (p_daton != (-1)) {
            const temp = new oDaton(true, p_daton);
            return temp;
        }
        else {
            const temp = new oDaton(false, 0);
            return temp;
        }

    }

    public static trans_homin_to_oHomin(p_homin: number): oHomin {
        if (p_homin != (-1)) {
            const temp = new oHomin(true, p_homin);
            return temp;
        }
        else {
            const temp = new oHomin(false, 0);
            return temp;
        }

    }

    public static trans_int_to_cell_str_v1(p_value_exit: boolean, p_value_content: number): string {
        if (p_value_exit == false) {
            return "";
        }
        // וכו MB100 בהמשך פה יש לטפל אם
        // וכו MB100 בהמשך פה יש לטפל אם
        // וכו MB100 בהמשך פה יש לטפל אם
        const stg = p_value_content.toString();
        return stg;
    }


    public static trans_cell_text_content_and_ilk_to_primitive_v1_obsolete(cell_text_content: string, ilk: Ilk): string {
        alert("obsolete");
        return "???";
    }


    public static quick_trans_enum_object_and_number_to_string(enum_object: Record<number, string>, num: number): string {
        // Typescript ל Javascript שים לב: פונקציה זו היתה קשה במעבר מ
        // Typescript ל Javascript שים לב: פונקציה זו היתה קשה במעבר מ
        // Typescript ל Javascript שים לב: פונקציה זו היתה קשה במעבר מ

        //Record<number, string> :יש לבצע enum עבור annotation שים לב אם רוצים לבצע
        //Record<number, string> :יש לבצע enum עבור annotation שים לב אם רוצים לבצע
        //Record<number, string> :יש לבצע enum עבור annotation שים לב אם רוצים לבצע

        // במהירות string ל number הוא אובייקט דו כיווני ולכן אפשר להמיר  enum ה gemeni לפי
        // במהירות string ל number הוא אובייקט דו כיווני ולכן אפשר להמיר  enum ה gemeni לפי
        // במהירות string ל number הוא אובייקט דו כיווני ולכן אפשר להמיר  enum ה gemeni לפי

        const result = enum_object[num];
        if (typeof result === 'string') {
            //alert(`result=${result}`)
            return result;
        }
        return null;
    }

    public static trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_text_content: string, ilk: Ilk, whisper: Whisper = null): oBase {

        if (ilk === undefined) {
            // javascript ב throw new Error() שים לב: בתאריך 5.2.26 זה פעם ראשונה שאני מבצע
            // javascript ב throw new Error() שים לב: בתאריך 5.2.26 זה פעם ראשונה שאני מבצע
            throw new Error("'ilk' cannot be undefined");
        }
        if (ilk === null) {
            // javascript ב throw new Error() שים לב: בתאריך 5.2.26 זה פעם ראשונה שאני מבצע
            // javascript ב throw new Error() שים לב: בתאריך 5.2.26 זה פעם ראשונה שאני מבצע
            throw new Error("'ilk' cannot be null");
        }
        if (ilk === Ilk.Unknown) {
            // javascript ב throw new Error() שים לב: בתאריך 5.2.26 זה פעם ראשונה שאני מבצע
            // javascript ב throw new Error() שים לב: בתאריך 5.2.26 זה פעם ראשונה שאני מבצע
            throw new Error("'ilk' cannot be Ilk.Unknown");
        }




        if (ilk == Ilk.oBool) {
            if (STR.string_contains_any_non_whitespace_char(cell_text_content) == true) {
                const bval = TRANS.trans_string_to_bool(cell_text_content, DefaultIfEmptyString.Unknown);
                return new oBool(true, bval);
            }
            else {
                return new oBool(false, false);
            }
        }
        if (ilk == Ilk.oColor) {
            return new oColor(true, 0);
        }
        if (ilk == Ilk.oCsv) {
            return new oCsv(true, "");
        }
        if (ilk == Ilk.oDatim) {
            new Error("oDatim shuld not be used");
        }
        if (ilk == Ilk.oDaton) {
            if (STR.string_contains_any_non_whitespace_char(cell_text_content) == true) {
                const number = TRANS.trans_daton_string_to_daton_int_v1(cell_text_content);
                return new oDaton(true, number);
            }
            else {
                return new oDaton(false, 0);
            }
        }
        if (ilk == Ilk.oDouble) {
            return new oDouble(false, 0);
        }
        if (ilk == Ilk.oFloat) {
            return new oFloat(false, 0);
        }
        if (ilk == Ilk.oHomin) {
            if (STR.string_contains_any_non_whitespace_char(cell_text_content) == true) {
                const number = TRANS.trans_homin_string_to_homin_int_v1(cell_text_content);
                return new oHomin(true, number);
            }
            else {
                return new oHomin(false, 0);
            }
        }
        if (ilk == Ilk.oInt16) {
            if (STR.string_contains_any_non_whitespace_char(cell_text_content) == true) {
                const number = TRANS.trans_string_to_int_return_minus_one_if_empty(cell_text_content);
                return new oInt16(true, number);
            }
            else {
                return new oInt16(false, 0);
            }
        }
        if (ilk == Ilk.oInt32) {
            if (STR.string_contains_any_non_whitespace_char(cell_text_content) == true) {
                const number = TRANS.trans_string_to_int_return_minus_one_if_empty(cell_text_content);
                return new oInt32(true, number);
            }
            else {
                return new oInt32(false, 0);
            }
        }
        if (ilk == Ilk.oInt64) {
            if (STR.string_contains_any_non_whitespace_char(cell_text_content) == true) {
                const number = TRANS.trans_string_to_int_return_minus_one_if_empty(cell_text_content);
                return new oInt64(true, number);
            }
            else {
                return new oInt64(false, 0);
            }
        }
        if (ilk == Ilk.oMay) {
            return new oMay(false, 0);
        }
        if (ilk == Ilk.oMemo) {
            if (STR.string_contains_any_non_whitespace_char(cell_text_content) == true) {
                return new oText(true, cell_text_content);
            }
            else {
                return new oText(false, "");
            }
        }
        if (ilk == Ilk.oText) {
            if (STR.string_contains_any_non_whitespace_char(cell_text_content) == true) {
                return new oText(true, cell_text_content);
            }
            else {
                return new oText(false, "");
            }
        }
        if (ilk == Ilk.oWkd) {
            return new oWkd(false, 0);
        }
        alert("error");
        return null;
    }    //CHUNK5-END
    //------------------------------------------------------------------------------------------------------------------
    //CHUNK6-START
    public static trans_now_to_daton(): number {
        const today = new Date();
        // עבור היום בחודש getDate() בחרו בשם מטעה javascript שים לב: השורה הבאה כנראה אינה טעות. כנראה שב
        // עבור היום בחודש getDate() בחרו בשם מטעה javascript שים לב: השורה הבאה כנראה אינה טעות. כנראה שב
        // עבור היום בחודש getDate() בחרו בשם מטעה javascript שים לב: השורה הבאה כנראה אינה טעות. כנראה שב
        // עבור היום בחודש getDate() בחרו בשם מטעה javascript שים לב: השורה הבאה כנראה אינה טעות. כנראה שב
        // עבור היום בחודש getDate() בחרו בשם מטעה javascript שים לב: השורה הבאה כנראה אינה טעות. כנראה שב
        const mday = today.getDate(); // שורה זו כנראה אינה טעות. ראה הערות למעלה
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const daton = UTL.MAKE_DATON(mday, month, year);
        return daton;
    }

    public static trans_script_application_json_to_catlist(id_str: string): Catlist {
        const catlist = new Catlist();
        catlist.Clear();
        const script_element = document.getElementById(id_str)?.textContent;
        if (!script_element) return catlist;
        const dataArray = JSON.parse(script_element);
        for (let i = 0; i < dataArray.length; i++) {
            const lp_code = dataArray[i].code;
            const lp_str = dataArray[i].value;
            catlist.Append(lp_code, lp_str);
        }
        return catlist;
    }

    public static trans_bool_str_to_bool(bool_as_str: string): boolean {
        if (bool_as_str == "true" || bool_as_str == "True") return true;
        if (bool_as_str == "false" || bool_as_str == "False") return false;
        return false; // we have to return something
    }


    public static trans_daton_to_wkd(p_daton: number): number {
        if (p_daton == -1) {
            return -1;
        }
        const mday = UTL.GET_DATON_MDAY(p_daton);
        const month = UTL.GET_DATON_MONTH(p_daton);
        const year = UTL.GET_DATON_YEAR(p_daton);
        const date = new Date(year, month - 1, mday);
        const temp = date.getDay();
        const wkd = (temp + 1);
        return wkd;
    }

    public static trans_csv_string_to_array_of_strings(p_csv_str: string): string[] {
        // פונקציה חדשה מתאריך 25.8.26
        if (p_csv_str == null) {
            return [];
        }
        const array_of_strings: string[] = p_csv_str.split(',');
        return array_of_strings;
    }


    public static trans_array_of_strings_to_array_of_numbers(p_array_of_strings: string[]): number[] {
        // פונקציה חדשה מתאריך 25.8.26
        // array of numbers ל csv_str להזכירך יש גם פונקציה שתפקידה להמיר ישירות
        // array of numbers ל csv_str להזכירך יש גם פונקציה שתפקידה להמיר ישירות
        // array of numbers ל csv_str להזכירך יש גם פונקציה שתפקידה להמיר ישירות
        if (p_array_of_strings == null) {
            return [];
        }
        const temp: number[] = [];
        for (let i = 0; i < p_array_of_strings.length; i++) {
            const item_str: string = p_array_of_strings[i];
            const item_num: number = Number(item_str);
            temp.push(item_num);
        }

        return temp;
    }

    public static trans_csv_string_to_array_of_numbers(p_csv_str: string): number[] {
        // פונקציה חדשה מתאריך 25.8.26
        if (p_csv_str == null) {
            return [];
        }
        const array_of_strings: string[] = TRANS.trans_csv_string_to_array_of_strings(p_csv_str);
        const array_of_numbers: number[] = TRANS.trans_array_of_strings_to_array_of_numbers(array_of_strings);
        return array_of_numbers;
    }

    public static trans_boolean_to_0_or_1_as_number(p_bval: boolean): number {
        if (p_bval == true) {
            return 1;
        }
        else {
            return 0;
        }
    }

    //CHUNK6-END
    //------------------------------------------------------------------------------------------------------------------

    public static trans_number_mb100_to_str_mb10(num_mb100: number): string {
        // חלוקה ב-100 והגבלה לספרה אחת אחרי הנקודה (שימוש ב-Math.floor מנקה שאריות)
        const num_mb10 = Math.floor(num_mb100 / 10) / 10;
        return num_mb10.toString();
    }

    public static trans_number_mb100_to_str_mb100(num_mb100: number): string {
        const num = num_mb100 / 100;
        return num.toString();
    }


    public static trans_string_to_lower_case(p_str: string): string {
        if (p_str == undefined || p_str == null) {
            alert("TRANS.trans_string_to_lower_case().p_str is undefined or null");
            return "";
        }
        const result_str = p_str.toLowerCase();
        return result_str;
    }

    public static trans_string_to_upper_case(p_str: string): string {
        if (p_str == undefined || p_str == null) {
            alert("TRANS.trans_string_to_upper_case().p_str is undefined or null");
            return "";
        }
        const result_str = p_str.toUpperCase();
        return result_str;
    }


    public static trans_daton_to_week(daton: number): number {
        let daton_of_wkd1: number = UTL.get_daton_of_preceding_sunday(daton);
        return daton_of_wkd1; // contains the date of Sunday of the week
    }

    public static trans_now_to_week(): number {
        let today_daton: number = TRANS.trans_now_to_daton();
        let week: number = this.trans_daton_to_week(today_daton);
        return week;
    }

    public static trans_week_to_prev_week(week: number): number {

        let daton1: number = week;
        let count: number = 7; // seven days in a week
        let prev_daton1: number = UTL.MultiplePrevDaton(daton1, count);

        return prev_daton1;
    }

    public static trans_week_to_next_week(week: number): number {

        let daton1: number = week;
        let count: number = 7; // seven days in a week
        let next_daton1: number = UTL.MultipleNextDaton(daton1, count);

        return next_daton1;
    }


    public static trans_true_to_visible_and_false_to_hidden(bval: boolean): string {
        if (bval == true) return "visible";
        else return "hidden";
    }
}

//-------------------------------------------------------------------------------------------------------
//                                  TABLE START
//-------------------------------------------------------------------------------------------------------


export class TABLE {

    // --- CHUNK 1 ---

    public static trans_table_element_and_row_number_to_row_element(table_element: HTMLTableElement, row_number: number): HTMLTableRowElement {
        const tbody_element: HTMLTableSectionElement = table_element.tBodies[0];
        if (tbody_element == null) {
            alert("TABLE.trans_table_element_and_row_number_to_row_element(). table has no body");
            return null;
        }
        const row_element: HTMLTableRowElement = tbody_element.rows[row_number];
        return row_element;
    }

    public static trans_table_element_and_row_number_and_column_number_to_cell_element(table_element: HTMLTableElement, row_number: number, column_number: number): HTMLTableCellElement {
        const row_element: HTMLTableRowElement = TABLE.trans_table_element_and_row_number_to_row_element(table_element, row_number);
        if (row_element == null) {
            alert("row_element == null (1)");
            return null;
        }
        const cell: HTMLTableCellElement = row_element.cells[column_number];
        return cell;
    }

    // --- CHUNK 2 ---

    public static given_table_element_add_class_str_to_row(table_element: HTMLTableElement, row_number: number, class_str: string): void {
        const row_element: HTMLTableRowElement = TABLE.trans_table_element_and_row_number_to_row_element(table_element, row_number);
        if (row_element == null) {
            alert("row_element == null (2)");
            return;
        }
        row_element.classList.add(class_str);
    }

    public static given_table_element_remove_class_str_from_row(table_element: HTMLTableElement, row_number: number, class_str: string
    ): void {
        const row_element: HTMLTableRowElement = TABLE.trans_table_element_and_row_number_to_row_element(table_element, row_number);
        if (row_element == null) {
            alert("row_element == null (3)");
            return;
        }
        row_element.classList.remove(class_str);
    }

    public static given_table_element_add_class_str_to_cell(
        table_element: HTMLTableElement,
        row_number: number,
        column_number: number,
        class_str: string
    ): void {
        const cell_element: HTMLTableCellElement = TABLE.trans_table_element_and_row_number_and_column_number_to_cell_element(table_element, row_number, column_number);
        if (cell_element == null) {
            let error_str = "TABLE.given_table_element_add_class_str_to_cell()\n\n";
            error_str += "cell_element == null\n\n";
            error_str += `row_number=${row_number}\n`;
            error_str += `column_number=${column_number}\n`;
            alert(error_str);
            return;
        }
        cell_element.classList.add(class_str);
    }

    public static given_table_element_remove_class_str_from_cell(
        table_element: HTMLTableElement,
        row_number: number,
        column_number: number,
        class_str: string
    ): void {
        const cell_element: HTMLTableCellElement = TABLE.trans_table_element_and_row_number_and_column_number_to_cell_element(table_element, row_number, column_number);
        if (cell_element == null) {
            let error_str = "TABLE.given_table_element_remove_class_str_from_cell()\n\n";
            error_str += "cell_element == null\n\n";
            error_str += `row_number=${row_number}\n`;
            error_str += `column_number=${column_number}\n`;
            alert(error_str);
            return;
        }
        cell_element.classList.remove(class_str);
    }

    public static trans_table_element_to_number_of_rows(table_element: HTMLTableElement): number {
        const tbody: HTMLTableSectionElement = table_element.tBodies[0];
        return tbody.rows.length;
    }

    public static trans_table_element_to_number_of_columns(table_element: HTMLTableElement): number {
        // hidden בשביל הזזת הסמן אין להשתמש בפונקציה זו כי היא לא בודקת עמודות 
        // במקום זו יש להשתמש בפונקציה הבאה
        // TABLE_CELL_MARKER_UTILITIES.CALC_NUMBER_OF_VISIBLE_COLUMNS_IN_ROW
        const thead_row_0: HTMLTableRowElement = table_element.tHead.rows[0];
        const number_of_columns: number = thead_row_0.cells.length;
        return number_of_columns;
    }

    public static slow_trans_row_element_to_row_number(table_element: HTMLTableElement, p_row_element: HTMLTableRowElement): number {
        const tbody: HTMLTableSectionElement = table_element.tBodies[0];
        if (tbody == null) return -1;
        if (tbody.contains(p_row_element) == false) return -1;

        for (let row_number = 0; row_number < tbody.rows.length; row_number++) {
            const lp_row_element: HTMLTableRowElement = tbody.rows[row_number];
            if (lp_row_element === p_row_element) {
                return row_number;
            }
        }
        return -1;
    }

    public static slow_trans_cell_element_to_column_number(table_element: HTMLTableElement, p_cell_element: HTMLTableCellElement): number {
        const row_element: HTMLTableRowElement = p_cell_element.closest("tr") as HTMLTableRowElement;
        if (row_element == null || row_element.contains(p_cell_element) == false) return -1;

        const cells: HTMLCollectionOf<HTMLTableCellElement> = row_element.cells;
        for (let column_number = 0; column_number < cells.length; column_number++) {
            if (cells[column_number] === p_cell_element) {
                return column_number;
            }
        }
        return -1;
    }

    // --- CHUNK 3 ---

    public static mouse_target_is_inside_table(target_element: HTMLElement): boolean {
        const table_element: HTMLTableElement = target_element.closest('table') as HTMLTableElement;
        return table_element != null;
    }

    public static trans_mouse_target_to_row_number(target_element: HTMLElement): number {
        if (TABLE.mouse_target_is_inside_table(target_element) == false) return -1;

        const row_element: HTMLTableRowElement = target_element.closest('tr') as HTMLTableRowElement;
        if (row_element == null) return -1;

        const table_element: HTMLTableElement = target_element.closest('table') as HTMLTableElement;
        if (table_element == null) return -1;

        return TABLE.slow_trans_row_element_to_row_number(table_element, row_element);
    }

    public static trans_mouse_target_to_column_number(target_element: HTMLElement): number {
        if (TABLE.mouse_target_is_inside_table(target_element) == false) return -1;

        const cell_element: HTMLTableCellElement = target_element.closest('td') as HTMLTableCellElement;
        if (cell_element == null) return -1;

        const table_element: HTMLTableElement = target_element.closest('table') as HTMLTableElement;
        if (table_element == null) return -1;

        return TABLE.slow_trans_cell_element_to_column_number(table_element, cell_element);
    }

    public static add_cell_at_end_of_row_of_table(row_element: HTMLTableRowElement, cell_text_content: string): void {
        const index: number = row_element.cells.length;
        const new_cell_element: HTMLTableCellElement = row_element.insertCell(index);
        new_cell_element.textContent = cell_text_content;
    }

    public static ADD_EMPTY_ROW_WITH_EMPTY_CELLS_AT_END_OF_TABLE(table_element: HTMLTableElement, n_of_cols: number): HTMLTableRowElement {
        const tbody: HTMLTableSectionElement = table_element.tBodies[0];
        const new_row_element: HTMLTableRowElement = tbody.insertRow();
        for (let i = 0; i < n_of_cols; i++) {
            TABLE.add_cell_at_end_of_row_of_table(new_row_element, "");
        }
        return new_row_element;
    }

    public static get_number_of_rows_in_table(table_element: HTMLTableElement): number {
        const tbody: HTMLTableSectionElement = table_element.tBodies[0];
        return tbody.rows.length;
    }

    // --- CHUNK 4 ---

    public static get_row_number_of_of_last_row_in_table(table_element: HTMLTableElement): number {
        const tbody: HTMLTableSectionElement = table_element.tBodies[0];
        return (tbody.rows.length - 1);
    }

    public static trans_table_element_and_row_and_col_to_cell_element(
        table_element: HTMLTableElement,
        row_number: number,
        col_number: number
    ): HTMLTableCellElement {
        const row_element: HTMLTableRowElement = TABLE.trans_table_element_and_row_number_to_row_element(table_element, row_number);
        const cell_element: HTMLTableCellElement = row_element.cells[col_number];
        return cell_element;
    }

    public static put_id_str_in_row_of_table(table_element: HTMLTableElement, row_number: number, id_str: string): void {
        const row_element: HTMLTableRowElement = TABLE.trans_table_element_and_row_number_to_row_element(table_element, row_number);
        if (row_element != null) {
            row_element.id = id_str;
        }
    }

    public static get_last_row_element_of_table(table_element: HTMLTableElement): HTMLTableRowElement {
        const tbody: HTMLTableSectionElement = table_element.tBodies[0];
        const n_of_rows: number = TABLE.get_number_of_rows_in_table(table_element);
        const last_row_element: HTMLTableRowElement = tbody.rows[n_of_rows - 1];
        return last_row_element;
    }

    public static trans_row_element_to_row_number(row_element: HTMLTableRowElement): number {
        // שימוש ב-sectionRowIndex כפי שציינת בהערה
        return row_element.sectionRowIndex;
    }

    public static get_last_row_number_of_table(table_element: HTMLTableElement): number {
        const number_of_rows: number = TABLE.trans_table_element_to_number_of_rows(table_element);
        if (number_of_rows == 0) return -1;
        return (number_of_rows - 1);
    }
}



//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
export class UTL {
    public static block_everything: boolean = false;
    public static modal_is_opened: boolean = false;
    private static sleep_async_delay_ms: number = 0; // should hold the delay in miliseconds

    public static GetRectWidth(rct: NRECT): number {
        const width: number = (rct.right - rct.left);
        return width;
    }

    public static GetRectHeight(rct: NRECT): number {
        const height: number = (rct.bottom - rct.top);
        return height;
    }

    public static y_is_above_rect(y: number, rct: NRECT): boolean {
        if (y < rct.top) {
            return true;
        }
        else {
            return false;
        }
    }

    public static y_is_bellow_rect(y: number, rct: NRECT): boolean {
        if (y > rct.bottom) {
            return true;
        }
        else {
            return false;
        }
    }

    public static x_is_left_to_rect(x: number, rct: NRECT): boolean {
        if (x < rct.left) {
            return true;
        }
        else {
            return false;
        }
    }

    public static x_is_right_to_rect(x: number, rct: NRECT): boolean {
        if (x > rct.right) {
            return true;
        }
        else {
            return false;
        }
    }

    public static element_is_part_of_table(element: HTMLElement): boolean {
        const closest_table: HTMLTableElement = element.closest("table") as HTMLTableElement;
        if (closest_table != null) {
            return true;
        }
        else {
            return false;
        }
    }

    public static element1_contains_element2(element1: HTMLElement, element2: HTMLElement): boolean {
        if (element1.contains(element2)) {
            return true;
        }
        else {
            return false;
        }
    }

    public static center_popup_element_inside_overlay_element(modal_element: HTMLElement, parent_element: HTMLElement): void {
        // Get dimensions of the parent and modal
        const parentWidth: number = parent_element.offsetWidth;
        const parentHeight: number = parent_element.offsetHeight;
        const modalWidth: number = modal_element.offsetWidth;
        const modalHeight: number = modal_element.offsetHeight;

        // Calculate the top-left position to center the modal
        const left: number = (parentWidth - modalWidth) / 2;
        const top: number = (parentHeight - modalHeight) / 2;

        // Apply the calculated position
        modal_element.style.position = 'absolute';
        modal_element.style.left = `${left}px`;
        modal_element.style.top = `${top}px`;
    }

    public static report_that_CreateFetchOptions_are_obsolete(): void {
        // הנחה שקיימת מחלקה בשם TIMING עם פונקציה TodayIsAfter
        if (TIMING.TodayIsAfter(9, 9, 2025) == true) {
            alert(`UTL.CreateFetchOptions functions should be obsolete`)
        }
    }

    public static CreateFetchOptions_v1(): RequestInit {
        //------------------------------------------------
        UTL.report_that_CreateFetchOptions_are_obsolete();
        //------------------------------------------------
        // fetch זה אמור להיות הערך כאילו לא שלחנו את הפרמטר השני של
        // fetch זה אמור להיות הערך כאילו לא שלחנו את הפרמטר השני של
        // fetch זה אמור להיות הערך כאילו לא שלחנו את הפרמטר השני של

        const options = new Object() as RequestInit;
        options.method = 'GET';
        return options;
    }

    public static CreateFetchOptions_v2(p_method: string, p_data: undefined): RequestInit {
        //------------------------------------------------
        UTL.report_that_CreateFetchOptions_are_obsolete();
        //------------------------------------------------
        const options = new Object() as RequestInit;
        options.method = p_method;
        options.headers = { 'Content-Type': 'application/json' };
        options.body = JSON.stringify(p_data);
        return options;
    }

    public static CreateFetchOptions_v3(): RequestInit {
        //------------------------------------------------
        UTL.report_that_CreateFetchOptions_are_obsolete();
        //------------------------------------------------
        const options = new Object() as RequestInit;
        options.method = "POST";
        options.cache = "no-store";
        return options;
    }

    public static CreateFetchOptions_v4(p_method: string, p_csrftoken: string, p_data: undefined): RequestInit {
        //------------------------------------------------
        UTL.report_that_CreateFetchOptions_are_obsolete();
        //------------------------------------------------
        const options = new Object() as RequestInit;
        options.method = p_method;
        // old of django: options.headers = { 'Content-Type': 'application/json', 'X-CSRFToken': p_csrftoken };
        options.headers = { 'Content-Type': 'application/json', 'RequestVerificationToken': p_csrftoken };

        if (p_data != null) {
            options.body = JSON.stringify(p_data);
        }
        return options;
    }

    public static CreateFetchOptions_v5(p_csrftoken: string): RequestInit {
        const options = new Object() as RequestInit;
        options.method = "POST";
        options.headers = { 'X-CSRFToken': p_csrftoken };
        options.cache = "no-store";
        return options;
    }

    public static GET_NEW_INDEX_Forward(p_curr_index: number, p_start_index: number, p_end_index: number): number {
        // MOVE_FOCUS_Forward שים לב שיש גם פונקציה דומה במטרה שלה לפונקציה הלזאת בשם
        // MOVE_FOCUS_Forward שים לב שיש גם פונקציה דומה במטרה שלה לפונקציה הלזאת בשם
        let index: number = p_curr_index;
        index++;
        if (index > p_end_index) {
            index = p_start_index;
        }
        return index;
    }

    public static GET_NEW_INDEX_Backward(p_curr_index: number, p_start_index: number, p_end_index: number): number {
        // MOVE_FOCUS_Backwards שים לב שיש גם פונקציה דומה במטרה שלה לפונקציה הלזאת בשם
        // MOVE_FOCUS_Backwards שים לב שיש גם פונקציה דומה במטרה שלה לפונקציה הלזאת בשם
        let index: number = p_curr_index;
        index--;
        if (index < p_start_index) {
            index = p_end_index;
        }
        return index;
    }

    public static MOVE_FOCUS_Forward(element1: HTMLElement, element2: HTMLElement, element3: HTMLElement = null): void {
        // GET_NEW_INDEX_Forward שים לב שיש גם פונקציה דומה במטרה שלה לפונקציה הלזאת בשם
        // GET_NEW_INDEX_Forward שים לב שיש גם פונקציה דומה במטרה שלה לפונקציה הלזאת בשם
        const freezed_activeElement = document.activeElement;
        if (freezed_activeElement === element1) {
            element2.focus();
        }
        if (freezed_activeElement === element2) {
            if (element3 == null) {
                element1.focus();
            }
            if (element3 != null) {
                element3.focus();
            }
        }
        if (element3 != null && freezed_activeElement === element3) {
            element1.focus();
        }
    }


    public static MOVE_FOCUS_Backwards(element1: HTMLElement, element2: HTMLElement, element3: HTMLElement = null): void {
        // GET_NEW_INDEX_Backwards שים לב שיש גם פונקציה דומה במטרה שלה לפונקציה הלזאת בשם
        // GET_NEW_INDEX_Backwards שים לב שיש גם פונקציה דומה במטרה שלה לפונקציה הלזאת בשם
        const freezed_activeElement = document.activeElement;
        if (freezed_activeElement === element1) {
            if (element3 == null) {
                element2.focus();
            }
            if (element3 != null) {
                element3.focus();
            }
        }
        if (freezed_activeElement === element2) {
            element1.focus();
        }
        if (element3 != null && freezed_activeElement === element3) {
            element2.focus();
        }
    }

    public static MakeElementFocusable(element: HTMLElement): void {
        // שאין אפשרות בברירת המחדל לבצע עבורם פוקוס <div> זה צריך לבצע עבור אלמנטים כמו למשל
        // שאין אפשרות בברירת המחדל לבצע עבורם פוקוס <div> זה צריך לבצע עבור אלמנטים כמו למשל
        // שאין אפשרות בברירת המחדל לבצע עבורם פוקוס <div> זה צריך לבצע עבור אלמנטים כמו למשל

        // שים לב שיש גם פונקציה הפוכה
        // שים לב שיש גם פונקציה הפוכה
        // שים לב שיש גם פונקציה הפוכה
        if (element.hasAttribute('tabindex') == false) {
            element.setAttribute('tabindex', '0');
        }
    }

    public static MakeElementUnFocusable(element: HTMLElement): void {
        // שאין אפשרות בברירת המחדל לבצע עבורם פוקוס <div> זה צריך לבצע עבור אלמנטים כמו למשל
        // שאין אפשרות בברירת המחדל לבצע עבורם פוקוס <div> זה צריך לבצע עבור אלמנטים כמו למשל
        // שאין אפשרות בברירת המחדל לבצע עבורם פוקוס <div> זה צריך לבצע עבור אלמנטים כמו למשל
        element.tabIndex = -1;
    }

    public static remove_outline_for_focusable_element(p_element: HTMLElement): void {
        p_element.style.outline = 'none';
    }

    public static show_which_element_has_focus(): void {
        const title_str: string = "Focused Element Info:\n------------------------\n";
        // הנחה שקיימת מחלקה TRANS
        const info_str: string = TRANS.trans_DOM_element_to_info_str(title_str, document.activeElement);
        alert(info_str);
    }

    public static string_contains_digit(str: string): boolean {
        const num: number = parseInt(str);
        if (isNaN(num) == true) {
            return false;
        }
        if (0 <= num && num <= 9) {
            return true;
        }
        return false;
    }


    public static zoo(num: number, minDigits: number): string {
        // strNum.padStart() :זה שונה מהמקור בגלל שאי אפשר היה להשתמש ב
        // strNum.padStart() :זה שונה מהמקור בגלל שאי אפשר היה להשתמש ב
        // strNum.padStart() :זה שונה מהמקור בגלל שאי אפשר היה להשתמש ב
        var strNum: string = String(num);
        // מימוש ידני שתואם ES5
        while (strNum.length < minDigits) {
            strNum = '0' + strNum;
        }
        return strNum;
    }

    public static GET_DATON_MDAY(daton: number): number {
        if (daton == (-1)) {
            return (-1);
        }
        const mday: number = daton % 100;
        return mday;
    }

    public static GET_DATON_MONTH(daton: number): number {
        if (daton == (-1)) {
            return (-1);
        }
        const temp: number = Math.floor(daton / 100);
        const month: number = temp % 100;
        return month;
    }

    public static GET_DATON_YEAR(daton: number): number {
        if (daton == (-1)) {
            return (-1);
        }
        const year: number = Math.floor(daton / 10000);
        return year;
    }

    public static MAKE_DATON(mday: number, month: number, year: number): number {
        const total: number = mday + 100 * month + 10000 * year;
        return total;
    }

    public static GET_HOMIN_HOUR(homin: number): number {
        if (homin === -1) {
            return (-1);
        }
        return Math.floor(homin / 60);
    }

    public static GET_HOMIN_MIN(homin: number): number {
        if (homin == (-1)) {
            return (-1);
        }
        return homin % 60;
    }

    public static MAKE_HOMIN(hour: number, min: number): number {
        return hour * 60 + min;
    }

    public static string_contains_int(p_str: string): boolean {
        const trimed_str: string = p_str.trim();
        const result: number = parseInt(p_str, 10);
        if (isNaN(result) == true) {
            return false;
        }
        if (result.toString() !== trimed_str) {
            // יש בהמשך להסביר למה צריך בדיקה זו
            return false;
        }
        return true;
    }

    public static char_is_whitespace(p_ch: string): boolean {
        if (p_ch == ' ') return true;
        if (p_ch == '\t') return true;
        if (p_ch == '\n') return true;
        if (p_ch == '\r') return true;
        return false;
    }

    public static perform_focus_and_select_of_input_element(input_element: HTMLInputElement): void {
        input_element.focus();
        input_element.select();
    }

    public static perform_focus_and_select_of_input_element_after_delay(input_element: HTMLInputElement, delay_in_milliseconds: number): void {
        //---------------------------------------------------------------------------------------------------
        //      אמר שיש דפדפנים שלא יודעים לעבוד כאשר  chatgpt התשובה היא ש ?delay למה אנחנו צריכים בכלל
        //                     delay מיד אחרי היצירה שלהם ולכן הצורך ב focus()/select() מבצעים את הפעולות
        //---------------------------------------------------------------------------------------------------
        setTimeout(UTL.perform_focus_and_select_of_input_element, delay_in_milliseconds, input_element);
    }

    public static hidden_input_exists(p_form: HTMLFormElement, p_name_as_str: string): boolean {
        // this function look for all inputs. not just "hideen" inputs
        const element = p_form.elements.namedItem(p_name_as_str);
        if (element != null) {
            return true;
        }
        else {
            return false;
        }
    }

    public static add_hidden_input_to_form(p_form: HTMLFormElement, p_name_as_str: string, p_value_as_str: string): void {
        if (p_value_as_str === undefined) {
            alert("UTL.add_hidden_input_to_form().value undefined");
        }
        if (p_value_as_str === null) {
            alert("UTL.add_hidden_input_to_form().value null");
        }

        const bool_val: boolean = UTL.hidden_input_exists(p_form, p_name_as_str);
        if (bool_val == true) {
            alert(`Error!!!\nUTL.add_hidden_input_to_form()\nform --already-- has input\n input name= ${p_name_as_str}`);
            return;
        }

        if (p_name_as_str == "csrfmiddlewaretoken") {
            alert("Error!!!\nUTL.add_hidden_input_to_form()\n--csrfmiddlewaretoken-- should not be called\nit belongs to --python--");
            return;
        }

        const input: HTMLInputElement = document.createElement('input');
        input.type = 'hidden';
        input.name = p_name_as_str;
        input.value = p_value_as_str;
        p_form.appendChild(input);
    }

    public static GetCookie(name: string): string {
        if (TIMING.TodayIsAfter(9, 9, 2025) == true) {
            alert(`Error!!!\nUTL.GetCookie()\n this function should not be called !!for now!!\n !!for now! it is related python\nIn future we do might want to use it`)
        }

        let cookieValue: string = null;
        if (document.cookie && document.cookie !== '') {
            const cookies: string[] = document.cookie.split(';');
            for (let cookie of cookies) {
                cookie = cookie.trim();
                if (cookie.startsWith(name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }

    public static ASP_GetAntiForgeryToken(): string {
        const token_element: HTMLInputElement = document.querySelector('input[name="__RequestVerificationToken"]') as HTMLInputElement;

        if (token_element == null) {
            alert("Anti-forgery token not found!");
            return null;
        }

        return token_element.value;
    }

    public static sleep_unused(ms: number): Promise<void> {
        // יש לפשט פונקציה זו בהמשך
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    private static sleep_async_executor_function(p_resolve: Function, p_reject: Function): void {
        // learn this javascript term "executor_function"
        // resolve → call this when the operation succeeds.
        // reject → call this if the operation fails.
        setTimeout(p_resolve, UTL.sleep_async_delay_ms);
    }

    public static sleep_async(ms: number): Promise<void> {
        UTL.sleep_async_delay_ms = ms;
        return new Promise(UTL.sleep_async_executor_function);
    }

    // CHUNK נפרד
    // CHUNK נפרד
    /* המשך מחלקת UTL */

    public static extract_last_number_from_string_as_number(str: string): number {
        var parts: string[] = str.split("-"); // Split the string by "-"
        var lastPart: string = parts[parts.length - 1]; // Get the last part
        var num: number = parseInt(lastPart, 10); // Convert it to an integer
        return num; // Return the final number
    }

    public static get_content_of_element_given_elcon(element: HTMLElement, elcon: Elcon): string {
        if (elcon == Elcon.textContent) {
            return element.textContent;
        }
        if (elcon == Elcon.innerHTML) {
            return element.innerHTML;
        }
        alert("error in function");
        return "";
    }

    public static put_content_in_element_given_elcon(element: HTMLElement, elcon: Elcon, new_content: string): void {
        if (elcon == Elcon.textContent) {
            element.textContent = new_content;
        }
        if (elcon == Elcon.innerHTML) {
            element.innerHTML = new_content;
        }
    }

    public static EXIST_ANY_GENERAL_OPENED_MODAL(): boolean {
        // js כפרמטר כיוון שהוא אמור להיות מוכר בכל קובץ document שים לב לא אמור להיות צורך להעביר את
        // (הערות המקור נשמרו...)
        if (true) {
            alert("this function should be obsolete since 29.10.2025");
        }


        if (DIALOG1.overlay_element != null && DIALOG1.overlay_element.parentNode === document.body) {
            return true;
        }
        if (DIALOG2.overlay_element != null && DIALOG2.overlay_element.parentNode === document.body) {
            return true;
        }
        if (DIALOG3.overlay_element != null && DIALOG3.overlay_element.parentNode === document.body) {
            return true;
        }
        if (DIALOG4.overlay_element != null && DIALOG4.overlay_element.parentNode === document.body) {
            return true;
        }
        if (DIALOG5.overlay_element != null && DIALOG5.overlay_element.parentNode === document.body) {
            return true;
        }
        if (DIALOG20.overlay_element != null && DIALOG20.overlay_element.parentNode === document.body) {
            return true;
        }
        if (DIALOG500.overlay_element != null && DIALOG500.overlay_element.parentNode === document.body) {
            return true;
        }
        if (DIALOG30.overlay_element != null && DIALOG30.overlay_element.parentNode === document.body) {
            return true;
        }

        //------------------------
        return false;
    }

    public static REMOVE_ANY_GENERAL_OPENED_MODAL(): void {
        // (הערות המקור נשמרו...)
        if (true) {
            alert("this function should be obsolete since 29.10.2025");
        }

        if (DIALOG1.overlay_element != null && DIALOG1.overlay_element.parentNode === document.body) {
            document.body.removeChild(DIALOG1.overlay_element);
        }
        if (DIALOG2.overlay_element != null && DIALOG2.overlay_element.parentNode === document.body) {
            document.body.removeChild(DIALOG2.overlay_element);
        }
        if (DIALOG3.overlay_element != null && DIALOG3.overlay_element.parentNode === document.body) {
            document.body.removeChild(DIALOG3.overlay_element);
        }
        if (DIALOG4.overlay_element != null && DIALOG4.overlay_element.parentNode === document.body) {
            document.body.removeChild(DIALOG4.overlay_element);
        }
        if (DIALOG5.overlay_element != null && DIALOG5.overlay_element.parentNode === document.body) {
            document.body.removeChild(DIALOG5.overlay_element);
        }
        if (DIALOG20.overlay_element != null && DIALOG20.overlay_element.parentNode === document.body) {
            document.body.removeChild(DIALOG20.overlay_element);
        }
        if (DIALOG500.overlay_element != null && DIALOG500.overlay_element.parentNode === document.body) {
            document.body.removeChild(DIALOG500.overlay_element);
        }
        if (DIALOG30.overlay_element != null && DIALOG30.overlay_element.parentNode === document.body) {
            document.body.removeChild(DIALOG30.overlay_element);
        }
    }

    public static GENERAL_VECTOR_UPDATE_FUNCTION(capsule: VECTOR_Capsule) {
        // השונים html כיוון שפונקציה זו יחסית מסובכת אנחנו בונים אותה כאן במקום לשכפל אותה הרבה פעמים בדפי
        // השונים html כיוון שפונקציה זו יחסית מסובכת אנחנו בונים אותה כאן במקום לשכפל אותה הרבה פעמים בדפי
        const status_element: HTMLElement = document.getElementById('id-scope-status');
        const entrance_exit_counters_element: HTMLElement = document.getElementById('id-scope-entrance_exit_counters');
        const errors_element: HTMLElement = document.getElementById('id-scope-errors');
        const mistakes_element: HTMLElement = document.getElementById('id-scope-mistakes');
        const wait_element: HTMLElement = document.getElementById('id-scope-wait');
        const sleep_element: HTMLElement = document.getElementById('id-scope-sleep');

        if (status_element != null) {
            status_element.textContent = `${capsule.NofSent}/${capsule.NofSuccess}`;
        }
        if (entrance_exit_counters_element != null) {
            entrance_exit_counters_element.textContent = `**${capsule.attempt_entrance_count}/${capsule.attempt_exit_count}`;
        }
        if (errors_element != null) {
            errors_element.textContent = `${capsule.NofErrors}`;
        }
        if (mistakes_element != null) {
            mistakes_element.textContent = `${capsule.NofMistakes}`;
        }
        if (wait_element != null) {
            if (capsule.wait_mode == false) {
                wait_element.style.backgroundColor = "magenta";
            }
            if (capsule.wait_mode == true) {
                wait_element.style.backgroundColor = "yellow";
            }
        }
        if (sleep_element != null) {
            if (capsule.sleep_mode == false) {
                sleep_element.style.backgroundColor = "magenta";
            }
            if (capsule.sleep_mode == true) {
                sleep_element.style.backgroundColor = "yellow";
            }
        }
    }


    public static array1_of_numbers_is_prefix_of_array2_of_numbers(array1_of_numbers: number[], array2_of_numbers: number[]): boolean {
        if (array1_of_numbers.length > array2_of_numbers.length) {
            return false;
        }
        for (let i = 0; i < array1_of_numbers.length; i++) {
            if (array1_of_numbers[i] != array2_of_numbers[i]) {
                return false;
            }
        }
        return true;
    }


    public static array1_of_strings_is_prefix_of_array2_of_strings(array1_of_strings: string[], array2_of_strings: string[]): boolean {
        if (array1_of_strings.length > array2_of_strings.length) {
            return false;
        }
        for (let i = 0; i < array1_of_strings.length; i++) {
            if (array1_of_strings[i] != array2_of_strings[i]) {
                return false;
            }
        }
        return true;
    }

    public static array1_of_chars_is_prefix_of_array2_of_chars(array1_of_chars: string[], array2_of_chars: string[]): boolean {
        // strings לכן אנחנו משתמשים בפונקציה שמתייחסת ל string אלא רק char טיפוס מסוג javascript/typescript להזכירך שאין ב
        // strings לכן אנחנו משתמשים בפונקציה שמתייחסת ל string אלא רק char טיפוס מסוג javascript/typescript להזכירך שאין ב
        // strings לכן אנחנו משתמשים בפונקציה שמתייחסת ל string אלא רק char טיפוס מסוג javascript/typescript להזכירך שאין ב
        const bval: boolean = UTL.array1_of_strings_is_prefix_of_array2_of_strings(array1_of_chars, array2_of_chars);
        return bval;
    }


    public static array1_of_numbers_and_array2_of_numbers_have_common_element(arr1: number[], arr2: number[]): boolean {
        // מטרת הפונקציה היא לבדוק האם יש לפחות איבר משותף אחד. או יותר
        for (let i = 0; i < arr1.length; i++) {
            for (let j = 0; j < arr2.length; j++) {
                if (arr1[i] === arr2[j]) {
                    return true;
                }
            }
        }
        return false;
    }

    public static array_of_numbers_contains_number(p_array_of_numbers: number[], p_number: number): boolean {
        if (p_array_of_numbers == null) {
            return false;
        }
        const found_index: number = p_array_of_numbers.indexOf(p_number);
        if (found_index != (-1)) {
            return true;
        }
        else {
            return false;
        }
    }


    public static array1_of_numbers_is_sub_set_of_array2_of_numbers(arr1: number[], arr2: number[]): boolean {
        // arr2 הינו תת קבוצה של arr1 מטרת הפונקציה היא לבדוק האם המערך
        for (let i = 0; i < arr1.length; i++) {
            if (UTL.array_of_numbers_contains_number(arr2, arr1[i]) == false) {
                return false; // נמצא איבר ב-arr1 שלא קיים ב-arr2
            }
        }
        return true; // כל האיברים ב-arr1 קיימים ב-arr2
    }

    public static is_any_of_elements_in_array1_of_numbers_exist_in_array2_of_numbers(arr1: number[], arr2: number[]): boolean {
        // arr2 נמצא בקבוצה של arr1 מטרת הפונקציה היא לבדוק האם לפחות אחד מאברי המערך
        for (let i = 0; i < arr1.length; i++) {
            if (UTL.array_of_numbers_contains_number(arr2, arr1[i]) == true) {
                return true; // arr2 כלומר שקיים איבר ב
            }
        }
        return false; // arr2 לא נמצא אף איבר ב
    }


    public static get_relative_complement_array_of_numbers_from_two_array_of_numbers(arr1: number[], arr2: number[]): number[] {
        // has not been tested
        // has not been tested
        // has not been tested
        // פונקציה זו אמורה להחזיר את הקבוצה (מערך) המשלימה
        // arr2 שאינם נמצאים ב arr1 כלומר כל אברי  
        const set2 = new Set<number>(arr2);
        const temp: number[] = [];
        for (let i = 0; i < arr1.length; i++) {
            const element = arr1[i];
            if (set2.has(element) == false) {
                temp.push(element);
            }
        }
        return temp;
    }

    /*
    public DontAlert(str: string): void {
        // do nothing
    }
    */

    public static get_maximum_common_prefix_length(array1_of_numbers: number[], array2_of_numbers: number[]): number {
        // משותף לשני המערכים הגדול ביותר prefix פונקציה זו אמורה להחזיר את גודלו של
        // example: 3,24,1,5,2,5,2 vs 3,24,1,6,6 =>> result 3 = length of: 3,24,1
        // example: 3,24,1,5,2,5,2 vs 3,24,1,6,6 =>> result 3 = length of: 3,24,1
        // example: 3,24,1,5,2,5,2 vs 3,24,1,6,6 =>> result 3 = length of: 3,24,1
        let min_length = Math.min(array1_of_numbers.length, array2_of_numbers.length);
        for (let i = 0; i < min_length; i++) {
            if (array1_of_numbers[i] !== array2_of_numbers[i]) {
               return i;
            }
        }
        return min_length; // אם הגענו לכאן אז כל התווים היו שווים בלולאה
    }

    public static NOT_FUNCTION(b: boolean): boolean {
        // not מטרתו להבליט את פעולת ה
        return (!b);
    }


    public static PromptNumber(p_num: number): void {
        alert(`PromptNumber(${p_num})`);
    }

    public static ReportNumber(p_num: number): void {
        alert(`ReportNumber(${p_num})`);
    }


    public static monthlength(year: number, month: number): number {

        switch (month) {
            case 1: return 31;
            case 2: if ((year % 4) != 0) return 28; else return 29;
            case 3: return 31;
            case 4: return 30;
            case 5: return 31;
            case 6: return 30;
            case 7: return 31;
            case 8: return 31;
            case 9: return 30;
            case 10: return 31;
            case 11: return 30;
            case 12: return 31;
        }

        alert("monthlength(): wrong parameters. year=" + year + " month=" + month);
        return 0; // if the month is invalid
    }

    public static NextDaton(daton: number): number {

        let mday: number = UTL.GET_DATON_MDAY(daton);
        let month: number = UTL.GET_DATON_MONTH(daton);
        let year: number = UTL.GET_DATON_YEAR(daton);

        mday++;
        if (mday > UTL.monthlength(year, month)) {
            month++;
            mday = 1;
            if (month > 12) {
                year++;
                month = 1;
            }
        }

        return UTL.MAKE_DATON(mday, month, year);
    }

    public static PrevDaton(daton: number): number {

        let mday: number = UTL.GET_DATON_MDAY(daton);
        let month: number = UTL.GET_DATON_MONTH(daton);
        let year: number = UTL.GET_DATON_YEAR(daton);

        mday--;
        if (mday < 1) {
            month--;
            if (month < 1) {
                year--;
                month = 12;
            }
            mday = UTL.monthlength(year, month);
        }

        return UTL.MAKE_DATON(mday, month, year);
    }


    public static MultiplePrevDaton(daton: number, count: number): number {

        let temp_daton: number = daton;

        let i: number;

        for (i = 1; i <= count; i++) {
            temp_daton = UTL.PrevDaton(temp_daton);
        }

        return temp_daton;
    }

    public static MultipleNextDaton(daton: number, count: number): number {

        let temp_daton: number = daton;

        let i: number;

        for (i = 1; i <= count; i++) {
            temp_daton = UTL.NextDaton(temp_daton);
        }

        return temp_daton;
    }

    public static NextWkd(wkd: number): number {

        if (wkd < 1 || wkd > 7) {
           UTL.ReportNumber(399);
        }

        if (wkd < 7) {
            return (wkd + 1);
        }
        else {
            return 1;
        }
    }

    public static get_daton_of_preceding_sunday(daton: number): number {

        // note: GetDatonOfSundayOfThisWeek() does the same thing

        let wkd: number = TRANS.trans_daton_to_wkd(daton);
        if (wkd < 1 || wkd > 7) {
            UTL.PromptNumber(234);
            return (-1);
        }

        let NofActions: number = wkd - 1;
        if (NofActions < 0 || NofActions > 6) {
            UTL.PromptNumber(234);
            return (-1);
        }

        let dtn: number = daton;
        for (let i: number = 0; i < NofActions; i++) {
            dtn = UTL.PrevDaton(dtn);
        }

        return dtn;
    }

}


//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------



export class EventsFifo {
    // מצד אחד ואין בה צורך מצד שני. אם בעתיד יהיה צורך בה יש לחזור לגירסה ישנה ולבדוק any הורדנו את כל התוכן של המחלקה הזאת בגלל שהכילה
    // מצד אחד ואין בה צורך מצד שני. אם בעתיד יהיה צורך בה יש לחזור לגירסה ישנה ולבדוק any הורדנו את כל התוכן של המחלקה הזאת בגלל שהכילה
    // מצד אחד ואין בה צורך מצד שני. אם בעתיד יהיה צורך בה יש לחזור לגירסה ישנה ולבדוק any הורדנו את כל התוכן של המחלקה הזאת בגלל שהכילה
}


//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------



//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

export class VECTOR_Capsule {
    NofSent: number;
    NofSuccess: number;
    NofErrors: number;
    NofMistakes: number;
    wait_mode: boolean;
    sleep_mode: boolean;
    attempt_entrance_count: number;  // אם המשתנים האלו לא יועילו צריך להוריד אותם הם מבלבלים
    attempt_exit_count: number;  // אם המשתנים האלו לא יועילו צריך להוריד אותם הם מבלבלים

    constructor() {
        this.NofSent = 0;
        this.NofSuccess = 0;
        this.NofErrors = 0;
        this.NofMistakes = 0;
        this.wait_mode = false;
        this.sleep_mode = false;
        this.attempt_entrance_count = 0;
        this.attempt_exit_count = 0;
    }
}

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------




export class TABLE_Location {
    public row: number;
    public column: number;

    public constructor(p_row: number = (-1), p_column: number = (-1)) {
        this.row = p_row;
        this.column = p_column;
    }
}


//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

export class VECTOR_Info {
    public fieldname: string;
    public fieldvalue: string;
    public row: number;
    public column: number;

    public constructor(p_fieldname: string = "", p_fieldvalue: string = "", p_row: number = (-1), p_column: number = (-1)) {
        this.fieldname = p_fieldname;
        this.fieldvalue = p_fieldvalue;
        this.row = p_row;
        this.column = p_column;
    }
}

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

type VECTOR_update_function_delegate = (vector_capsule: VECTOR_Capsule) => void;

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

export class VECTOR_Task {
    public url: string;
    public options: RequestInit; // הטיפוס הסטנדרטי של fetch options
    public info: VECTOR_Info;
    public update_function: VECTOR_update_function_delegate;

    constructor() {
        this.url = "";
        this.options = null;
        this.info = null;
        this.update_function = null;
    }
}



//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------



//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
// EMITTERRRRR
export class VECTOR {
    constructor() {
        // note: this is a constructor function
        // note: this is a constructor function
        // note: this is a constructor function
    }

    // The queue (just an array of fetch tasks)
    public static QUEUE_ARRAY: VECTOR_Task[] = []; // javascript שים לב שאנחנו מיישמים את התור באמצעות מערך רגיל ב
    public static IsProcessingQueue: boolean = false;

    public static CAPSULE: VECTOR_Capsule = new VECTOR_Capsule();

    public static CallUpdate(update_function: VECTOR_update_function_delegate): void {
        update_function(VECTOR.CAPSULE);
    }


    public static QUEUE_enqueue(task: VECTOR_Task): void {
        VECTOR.QUEUE_ARRAY.push(task);
    }

    public static QUEUE_HasItems(): boolean {
        if (VECTOR.QUEUE_ARRAY.length > 0) {
            return true;
        }
        else {
            return false;
        }
    }

    public static QUEUE_dequeue(): VECTOR_Task {
        const task: VECTOR_Task = VECTOR.QUEUE_ARRAY.shift();
        return task;
    }

    public static async Attempt(task: VECTOR_Task): Promise<boolean> {
        //----------------------------------------------------------------------------------------
        //                                                                ?Attempt מה המשמעות של
        // 1. חד כיוונית אינה מחזירה מידע
        // 2. success/failre אמנם אינה מחזירה מידע אבל אמורה להחזיר ערך בוליאני שאומר האם
        // 3. (fire and forget) כיוון שאינה מחזירה מידע מתאימה רק לפעולות שגר ושכח
        // 4. Attempt מבצעת נסיון אחד בלבד. אם צריך עוד נסיונות זאת אחריות הפונקציה הקוראת
        //----------------------------------------------------------------------------------------

        // פונקציה זו מניחה שאין צורך לקבל מידע חזרה. אבל צריך לדעת אם הפעולה היתה תקינה או לא
        // פונקציה זו מניחה שאין צורך לקבל מידע חזרה. אבל צריך לדעת אם הפעולה היתה תקינה או לא
        // פונקציה זו מניחה שאין צורך לקבל מידע חזרה. אבל צריך לדעת אם הפעולה היתה תקינה או לא
        // returns true if antyhing ok and false if not

        VECTOR.CAPSULE.attempt_entrance_count += 1; VECTOR.CallUpdate(task.update_function);
        try {
            //debugger;
            VECTOR.CAPSULE.wait_mode = true; VECTOR.CallUpdate(task.update_function);
            const response = await fetch(task.url, task.options);
            //await UTL.sleep_async(200); // זמן קצר מאד או בכלל לא
            VECTOR.CAPSULE.wait_mode = false; VECTOR.CallUpdate(task.update_function);


            if (response == null) {
                console.error('Fetch failed:response not ok');
                VECTOR.CAPSULE.attempt_exit_count += 1; VECTOR.CallUpdate(task.update_function);
                return false;
            }

            if (response.ok == false) {
                console.error('Fetch failed:response not ok');
                VECTOR.CAPSULE.attempt_exit_count += 1; VECTOR.CallUpdate(task.update_function);
                return false;
            }
            VECTOR.CAPSULE.attempt_exit_count += 1; VECTOR.CallUpdate(task.update_function);
            return true; // i.e. it was succefull
        }
        catch (err) {
            if (true) {
                // wait_mode אירע לפני השורה שצריכה לעדכן את exeption כיוון שהוא לא בוצע בגלל שה VECTOR.CAPSULE.wait_mode אם הגענו לכאן אז חייבים לכבות את
                // wait_mode אירע לפני השורה שצריכה לעדכן את exeption כיוון שהוא לא בוצע בגלל שה VECTOR.CAPSULE.wait_mode אם הגענו לכאן אז חייבים לכבות את
                VECTOR.CAPSULE.wait_mode = false; VECTOR.CallUpdate(task.update_function);
            }

            VECTOR.CAPSULE.NofMistakes += 1;
            console.error('Fetch failed:', err);
            // הבאים כן יצליחו rounds אחד. יכול להיות שה round כאן לא אמורים לצבוע כלום כי זה רק
            // הבאים כן יצליחו rounds אחד. יכול להיות שה round כאן לא אמורים לצבוע כלום כי זה רק
            // הבאים כן יצליחו rounds אחד. יכול להיות שה round כאן לא אמורים לצבוע כלום כי זה רק
            VECTOR.CAPSULE.attempt_exit_count += 1; VECTOR.CallUpdate(task.update_function);
            return false; // i.e. it was failed
        }
    }

    public static async Persist(task: VECTOR_Task): Promise<boolean> {
        let counter = 0;
        while (true) {
            const result_of_round = await VECTOR.Attempt(task);
            if (result_of_round == true) {
                // i.e. successfull fetch
                VECTOR.CAPSULE.NofSuccess++; VECTOR.CallUpdate(task.update_function);
                return true;
            }
            VECTOR.CAPSULE.sleep_mode = true; VECTOR.CallUpdate(task.update_function);
            await UTL.sleep_async(300);
            VECTOR.CAPSULE.sleep_mode = false; VECTOR.CallUpdate(task.update_function);
            counter += 1;
            if (counter > 5) {
                // i.e. all rounds failed so this function is failed
                // כאן יש לתת אידיקציה של תקלה
                //queue_error_encounered = true;
                VECTOR.CAPSULE.NofErrors++; VECTOR.CallUpdate(task.update_function);
                //alert("problem");
                DIALOG500.create_dialog_INA(VECTOR.QUEUE_ARRAY, task);
                return false;
            }
        }
    }

    // Process queue tasks one by one
    public static async Process(): Promise<void> {
        // await בגלל שמכילה async חייבת להיות fire and forget פונקציה זו אף על פי שאינה מחזירה ערך כלשהו ואף על פי שהיא
        // await בגלל שמכילה async חייבת להיות fire and forget פונקציה זו אף על פי שאינה מחזירה ערך כלשהו ואף על פי שהיא
        // await בגלל שמכילה async חייבת להיות fire and forget פונקציה זו אף על פי שאינה מחזירה ערך כלשהו ואף על פי שהיא
        VECTOR.IsProcessingQueue = true;
        while (VECTOR.QUEUE_HasItems() == true) {
            const task = /*VECTOR.QUEUE_ARRAY.shift()*/VECTOR.QUEUE_dequeue();
            VECTOR.CAPSULE.NofSent++; VECTOR.CallUpdate(task.update_function);
            await VECTOR.Persist(task);
            await UTL.sleep_async(300);
            // No need to return or resolve anything here
        }
        VECTOR.IsProcessingQueue = false;
    }




    public static Send(p_url: string, p_options: RequestInit, p_info: VECTOR_Info, p_update_function: VECTOR_update_function_delegate): void {
        // fire and forget פונקציה זו היא await כי אינה מכילה async פונקציה זו אינה מסוג
        // fire and forget פונקציה זו היא await כי אינה מכילה async פונקציה זו אינה מסוג
        // fire and forget פונקציה זו היא await כי אינה מכילה async פונקציה זו אינה מסוג
        // fire and forget פונקציה זו היא await כי אינה מכילה async פונקציה זו אינה מסוג


        const task: VECTOR_Task = new VECTOR_Task();
        task.url = p_url;
        task.options = p_options;
        task.info = p_info;
        task.update_function = p_update_function;


        if (VECTOR.CAPSULE.NofErrors > 0) {
            debugger;
            // ננסה את זה. צריך ללמוד איך זה מתנהג
            DIALOG500.create_dialog_INA(VECTOR.QUEUE_ARRAY, task);
            return;
        }

        //VECTOR.QUEUE_ARRAY.push(task);
        VECTOR.QUEUE_enqueue(task)
        if (VECTOR.IsProcessingQueue == false) {
            VECTOR.Process();
        }
    }
}

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------



export class CdFnCntPayload {
    // Cd = Code; Fn = Field Name; Cnt = ConTetnet
    public record_code_as_str: string;
    public field_name_str: string;
    public field_content_str: string;

    constructor() {
        this.record_code_as_str = "";
        this.field_name_str = "";
        this.field_content_str = "";
    }
}

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------


export enum COMM_LOGIC_TYPE {
    // COMM = COMMunication
    // COMM = COMMunication
    // COMM = COMMunication
    undefined = 0,
    slow = 1,
    quick = 2
}


//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------


//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

export class TABLE_SORT_ROWS_AUX_FUNCTIONS {
    // מחלקה חדשה מתאריך 25.7.26
    // מחלקה חדשה מתאריך 25.7.26
    // מחלקה חדשה מתאריך 25.7.26

    private static trans_table_body_element_to_array_of_table_row_elements(tbody_element: HTMLTableSectionElement): HTMLTableRowElement[] {
        const array_of_elements: HTMLTableRowElement[] = Array.from(tbody_element.rows);
        return array_of_elements;
    }

    private static reorder_table_given_array_of_row_elements(table_element: HTMLTableElement, array_of_row_elements: HTMLTableRowElement[]): void {
        //---------------------------------------------------------------------------------------
        //             :שים לב שפונקציה זו רק מוסיפה איברים ולא מורידה איברים מהטבלה. נשאלת השאלה
        //                                שאלה: אז באיזה מקום מורידים את האברים? תשובה: בשום מקום
        //         שאלה: אז האם האיברים מופיעים פעמיים? תשובה: לא. הם מופיעים רק פעם אחת כי שרצוי
        //                                                        ?שאלה אז איך זה פועל באופן תקין
        //            היא אינה מוסיפה אותו פעמיים tbody.appendChild() תשובה: כאשר קוראים לפונקציה
        //                               אלא מורידה אותו מהמקום הקיים ואז מוסיפה אותו לסוף הרשימה
        //---------------------------------------------------------------------------------------
        //                      גם!! מורידה !!וגם!! מוסיפה!! tbody.appendChild() :לסיכום הפונקציה
        //---------------------------------------------------------------------------------------
        const tbody: HTMLTableSectionElement = table_element.tBodies[0];
        for (let i: number = 0; i < array_of_row_elements.length; i++) {
            const row: HTMLTableRowElement = array_of_row_elements[i];
            tbody.appendChild(row);
        }
    }

    public static sortTable(table_element: HTMLTableElement, compare_function: (row1: HTMLTableRowElement, row2: HTMLTableRowElement) => number): void {
        const tbody: HTMLTableSectionElement = table_element.tBodies[0];
        const row_elements: HTMLTableRowElement[] = TABLE_SORT_ROWS_AUX_FUNCTIONS.trans_table_body_element_to_array_of_table_row_elements(tbody);
        row_elements.sort(compare_function);
        TABLE_SORT_ROWS_AUX_FUNCTIONS.reorder_table_given_array_of_row_elements(table_element, row_elements);
    }
}

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

export class TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS {
     private static trans_table_element_to_n_of_columns(table_element: HTMLTableElement): number {
        // מבצע בדיקה לפי השורה הראשונה
        // מבצע בדיקה לפי העמודה הראשונה
        // מבצע בדיקה לפי העמודה הראשונה
        if (table_element.rows.length === 0) {
            return 0;
        }
        return table_element.rows[0].cells.length;
    }

    private static alert_if_array_of_fids_contain_duplicates(array_of_fids: string[]): boolean {
        // should return true if there is a problem
        // should return true if there is a problem
        // should return true if there is a problem
        const seen: Set<string> = new Set<string>();
        for (const fid of array_of_fids) {
            if (seen.has(fid)) {
                alert(`alert_if_array_of_fids_contain_duplicates().\nDuplicate fid found: "${fid}"`);
                return true;
            }
            seen.add(fid);
        }
        return false;
    }


    private static alert_if_fids_not_exist_in_table(table_element: HTMLTableElement, array_of_fids: string[]): boolean {
        // should return true if there is a problem
        // should return true if there is a problem
        // should return true if there is a problem
        const table_fids: string[] = TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.get_all_fids_of_table_element(table_element);
        for (const fid of array_of_fids) {
            if (TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.array_of_strings_contains_string(table_fids, fid) == false) {
                alert("FID does not exist in table: " + fid);
                alert(`alert_if_fids_not_exist_in_table().\nfid not found: "${fid}"`);
                return true;
            }
        }
        return false;
    }


    private static isValidPermutation(permutation: number[], size: number): boolean {
        if (permutation.length !== size) {
            return false;
        }
        const found: boolean[] = new Array(size).fill(false);
        for (const value of permutation) {

            if (value < 0 || value >= size) {
                return false;
            }

            if (found[value]) {
                return false;
            }

            found[value] = true;
        }
        return true;
    }


    private static reorder_table_row_given_permutation(row_element: HTMLTableRowElement, permutation: number[]): void {
        //-----------------------------------------------------------------------------------------
        //  פונקציה זו היא פונקצית עזר לפונקציה המרכזית שמבצעת את סידור העמודות מחדש על פי פרמוטציה
        //                                                 AI אם יש בעיה יש להעזר ב AI נכתבה על ידי
        //-----------------------------------------------------------------------------------------
        const cells: HTMLTableCellElement[] = Array.from(row_element.cells);
        const newCells: HTMLTableCellElement[] = [];

        for (const oldIndex of permutation) {

            if (oldIndex < cells.length) {
                newCells.push(cells[oldIndex]);
            }
        }
        row_element.innerHTML = "";
        for (const cell of newCells) {
            row_element.appendChild(cell);
        }
    }


     private static reorder_table_columns_given_permutation(table_element: HTMLTableElement, permutation: number[]): void {
        //-----------------------------------------------------------------------------
        //  פונקציה זו היא הפונקציה המרכזית שמבצעת את סידור העמודות מחדש על פי פרמוטציה
        //                                     AI אם יש בעיה יש להעזר ב AI נכתבה על ידי
        //-----------------------------------------------------------------------------
        const table_no_of_columns: number = TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.trans_table_element_to_n_of_columns(table_element);
        const permutation_no_of_columns: number = permutation.length;
        if (table_no_of_columns != permutation_no_of_columns) {
            alert("reorder_table_columns_given_permutation(). table_no_of_columns != permutation_no_of_columns")
            return;
        }
        if (TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.isValidPermutation(permutation, table_no_of_columns) == false) {
            alert("reorder_table_columns_given_permutation(). Invalid permutation");
            return;
        }
        /*
        for (const row of Array.from(table_element.rows)) {
            const cells: HTMLTableCellElement[] = Array.from(row.cells);
            const newCells: HTMLTableCellElement[] = [];
            for (const oldIndex of permutation) {

                if (oldIndex < cells.length) {
                    newCells.push(cells[oldIndex]);
                }
            }
            row.innerHTML = "";
            for (const cell of newCells) {
                row.appendChild(cell);
            }
        }*/
        for (const row_element of Array.from(table_element.rows)) {
            TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.reorder_table_row_given_permutation(row_element, permutation);
        }
    }


     private static trans_table_element_and_fid_to_column_index(table_element: HTMLTableElement, fid: string): number {
        if (table_element.rows.length === 0) {
            return (-1);
        }
        const headerRow: HTMLTableRowElement = table_element.rows[0];
        for (let columnIndex = 0; columnIndex < headerRow.cells.length; columnIndex++) {
            const cellFid: string = headerRow.cells[columnIndex].getAttribute("data-fid");
            if (cellFid === fid) {
                return columnIndex;
            }
        }
        return (-1);
    }


     private static trans_table_element_and_array_of_fids_to_array_of_columns(table_element: HTMLTableElement, fids: string[]): number[] {

        // לרשימה של מספרי העמודות לפי הסדר fids פונקציה זו תפקידה להמיר רשימת של
        // לרשימה של מספרי העמודות לפי הסדר fids פונקציה זו תפקידה להמיר רשימת של
        // לרשימה של מספרי העמודות לפי הסדר fids פונקציה זו תפקידה להמיר רשימת של
        // לרשימה של מספרי העמודות לפי הסדר fids פונקציה זו תפקידה להמיר רשימת של
        const columnIndexes: number[] = [];
        for (const fid of fids) {
            const columnIndex: number = TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.trans_table_element_and_fid_to_column_index(table_element, fid);
            if (columnIndex != (-1)) {
                columnIndexes.push(columnIndex);
            }
            else {
                alert("FID not found: " + fid);
                // do not push anything
            }
        }

        return columnIndexes;
    }


     private static get_all_fids_of_table_element(table_element: HTMLTableElement): string[] {
        const result: string[] = [];
        if (table_element.rows.length === 0) {
            return result;
        }
        const headerRow: HTMLTableRowElement = table_element.rows[0];
        for (const cell of Array.from(headerRow.cells)) {
            const fid: string | null = cell.getAttribute("data-fid");
            if (fid !== null) {
                result.push(fid);
            }
        }
        return result;
    }




    private static array_of_strings_contains_string(array: string[], value: string): boolean {
        return array.indexOf(value) >= 0;
    }


     private static create_unition_of_two_array_of_strings(first: string[], second: string[]): string[] {
        const result: string[] = [];
        for (const item of first) {
            result.push(item);
        }
        for (const item of second) {
            result.push(item);
        }
        return result;
    }


     private static trans_full_array_of_fids_and_partial_array_of_fids_to_missing_list_of_fids(all_fids: string[], partialFids: string[]): string[] {
        const missingFids: string[] = [];
        for (const fid of all_fids) {
            if (TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.array_of_strings_contains_string(partialFids, fid) == false) {
                missingFids.push(fid);
            }
        }
        return missingFids;
    }

     private static trans_table_element_and_partial_array_of_fids_to_array_of_missing_fids(table_element: HTMLTableElement, partial_array_of_fids: string[]): string[] {
        const all_fids_in_table: string[] = TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.get_all_fids_of_table_element(table_element);
        const missing_array_of_fids = TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.trans_full_array_of_fids_and_partial_array_of_fids_to_missing_list_of_fids(all_fids_in_table, partial_array_of_fids);
        return missing_array_of_fids;
    }

     private static completeFidList(allFids: string[], partialFids: string[]): string[] {
        const result: string[] = [];
        // קודם מוסיפים את מה שהמשתמש ביקש, לפי הסדר שלו
        for (const fid of partialFids) {
            if (allFids.indexOf(fid) >= 0) {
                result.push(fid);
            }
        }
        // אחר כך מוסיפים את מה שחסר
        for (const fid of allFids) {
            if (result.indexOf(fid) < 0) {
                result.push(fid);
            }
        }
        return result;
    }

     private static trans_table_element_and_partial_array_of_fids_to_complete_array_of_fids_ordered(table_element: HTMLTableElement, partial_array_of_fids: string[]): string[] {
        const all_fids_in_table: string[] = TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.get_all_fids_of_table_element(table_element);
        const complete_array_of_fids = TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.completeFidList(all_fids_in_table, partial_array_of_fids);
        return complete_array_of_fids;
    }

    private static trans_table_element_and_disired_array_of_fields_to_permutation(table_element: HTMLTableElement, desiredFids: string[]): number[] {
        // להזכירך שפונקצית סידור העמודות המרכזית עובד על פרמוטציה כלומר תמיד צריך לסדר את כל העמודות
        // להזכירך שפונקצית סידור העמודות המרכזית עובד על פרמוטציה כלומר תמיד צריך לסדר את כל העמודות
        // להזכירך שפונקצית סידור העמודות המרכזית עובד על פרמוטציה כלומר תמיד צריך לסדר את כל העמודות
        // להזכירך שפונקצית סידור העמודות המרכזית עובד על פרמוטציה כלומר תמיד צריך לסדר את כל העמודות
        // להזכירך שפונקצית סידור העמודות המרכזית עובד על פרמוטציה כלומר תמיד צריך לסדר את כל העמודות
        const permutation: number[] = [];
        const currentFids: string[] = TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.get_all_fids_of_table_element(table_element);
        if (desiredFids.length !== currentFids.length) {
            // בטבלה. ולא רשימה חלקית fids חייב להכיל את כל הרשימה של ה desiredFids להזכירך ש:
            // בטבלה. ולא רשימה חלקית fids חייב להכיל את כל הרשימה של ה desiredFids להזכירך ש:
            // בטבלה. ולא רשימה חלקית fids חייב להכיל את כל הרשימה של ה desiredFids להזכירך ש:
            alert("createPermutationFromFids(). desiredFids must include all fids it should not be partial array.");
        }

        for (const fid of desiredFids) {
            const index: number = currentFids.indexOf(fid);
            if (index >= 0) {
                permutation.push(index);
            }
        }
        if (permutation.length !== currentFids.length) {
            alert("createPermutationFromFids(). Invalid column order. Missing fid.");
        }
        return permutation;
    }



    private static reorder_columns_in_table_element_by_fids_given_full_array_of_fids(table_element: HTMLTableElement, full_array_of_fids: string[]): void {
        // כי הקוד מניח שיש פרמוטציה מלאה על כל העמודות וזה כיוון שפונקצית המיון הבסיסית יודעת לעבוד על פרמוטציה שלימה full_array_of_fids פונקציה זו חייבת לקבל
        // כי הקוד מניח שיש פרמוטציה מלאה על כל העמודות וזה כיוון שפונקצית המיון הבסיסית יודעת לעבוד על פרמוטציה שלימה full_array_of_fids פונקציה זו חייבת לקבל
        // כי הקוד מניח שיש פרמוטציה מלאה על כל העמודות וזה כיוון שפונקצית המיון הבסיסית יודעת לעבוד על פרמוטציה שלימה full_array_of_fids פונקציה זו חייבת לקבל
        const permutation: number[] = TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.trans_table_element_and_disired_array_of_fields_to_permutation(table_element, full_array_of_fids);
        TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.reorder_table_columns_given_permutation(table_element, permutation);
    }



    private static set_columns_visibility_given_table_element_and_array_of_columns(table_element: HTMLTableElement, columnIndexes: number[], visible: boolean): void {
        // visible מחרוזת ריקה זה הופך אותו ל display שים לב: דבר חדש מבחינתי שאם נותנים ל
        // visible מחרוזת ריקה זה הופך אותו ל display שים לב: דבר חדש מבחינתי שאם נותנים ל
        // visible מחרוזת ריקה זה הופך אותו ל display שים לב: דבר חדש מבחינתי שאם נותנים ל
        const displayValue: string = visible ? "" : "none";
        for (const row of Array.from(table_element.rows)) {
            for (const columnIndex of columnIndexes) {
                if (row.cells.length > columnIndex) {
                    row.cells[columnIndex].style.display = displayValue;
                }
            }
        }
    }

     private static set_columns_visibility_given_table_element_and_array_of_fids(table_element: HTMLTableElement, array_of_fids: string[], visible: boolean): void {
        const array_of_columns = TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.trans_table_element_and_array_of_fids_to_array_of_columns(table_element, array_of_fids);
        TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.set_columns_visibility_given_table_element_and_array_of_columns(table_element, array_of_columns, visible);
    }



    public static reorder_columns_in_table_element_by_fids_given_partial_list_of_fids(table_element: HTMLTableElement, partial_array_of_fids: string[]): void {
        if (TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.alert_if_fids_not_exist_in_table(table_element, partial_array_of_fids) == true) {
            return;
        }
        if (TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.alert_if_array_of_fids_contain_duplicates(partial_array_of_fids) == true) {
            return;
        }
        const array_of_missing_fids = TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.trans_table_element_and_partial_array_of_fids_to_array_of_missing_fids(table_element, partial_array_of_fids);
        const array_of_full_list_of_fids_with_desired_order = TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.create_unition_of_two_array_of_strings(partial_array_of_fids, array_of_missing_fids);
        // להזכירך שיש ליצור רשימה של כל השדות כי הפונקציה המרכזית של סידור העמודות יודעת לעבוד רק אם היא מקבלת את כל השדות
        TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.reorder_columns_in_table_element_by_fids_given_full_array_of_fids(table_element, array_of_full_list_of_fids_with_desired_order);
        // partial_array_of_fids לכל העמודות ברשימה visibility = true השורה הבאה תפקידה להציב
        TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.set_columns_visibility_given_table_element_and_array_of_fids(table_element, partial_array_of_fids, true);
        // array_of_missing_fids לכל העמודות ברשימה visibility = true השורה הבאה תפקידה להציב
        TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.set_columns_visibility_given_table_element_and_array_of_fids(table_element, array_of_missing_fids, false);
    }

    // PUT BEFORE HERE
    // PUT BEFORE HERE
    // PUT BEFORE HERE
}

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

export class TABLE_CELL_MARKER_UTILITIES {
    // מחלקה חדשה מתאריך 15.10.26
    // מחלקה חדשה מתאריך 15.10.26
    // מחלקה חדשה מתאריך 15.10.26
    public static CALC_NUMBER_OF_COLUMNS_IN_ROW(table_element: HTMLTableElement, row_number: number): number {
        // ופונקציה זו מתאימה לפעולות הצביעה אבל לא לחישוב תזוזת הסמן hidden פונקציה תפקידה לחשב את כל העמודות כולל אלה שבמצב
        // CALC_NUMBER_OF_VISIBLE_COLUMNS_IN_ROW() לחישוב תזוזת הסמן יש להשתמש בפונקציה
        const row_element: HTMLTableRowElement = TABLE.trans_table_element_and_row_number_to_row_element(table_element, row_number);
        if (row_element == null) {
            console.error("TABLE_CELL_MARKER_UTILITIES.CALC_NUMBER_OF_COLUMNS_IN_ROW: Row not found", row_number);
            return 0;
        }
        return row_element.cells.length;
    }

    public static CALC_NUMBER_OF_VISIBLE_COLUMNS_IN_ROW(table_element: HTMLTableElement, row_number: number): number {
        // פונקציה זו מתאימה לתזוזת המסך אבל לא לצביעה not hidden פונקציה זו תפקידה לחשב את כל העמודות שהן נראות
        // CALC_NUMBER_OF_COLUMNS_IN_ROW() כדי לצבוע צריך להשתמש בפונקציה
        const row_element: HTMLTableRowElement = TABLE.trans_table_element_and_row_number_to_row_element(table_element, row_number);
        if (row_element == null) {
            console.error("TABLE_CELL_MARKER_UTILITIES.CALC_NUMBER_OF_VISIBLE_COLUMNS_IN_ROW: Row not found", row_number);
            return 0;
        }
        debugger;
        let number_of_visible_columns: number = 0;
        for (let column_number = 0; column_number < row_element.cells.length; column_number++) {
            const cell_element: HTMLTableCellElement = row_element.cells[column_number];
            const cell_style: CSSStyleDeclaration = window.getComputedStyle(cell_element);
            const cell_visibility = cell_style.visibility;
            const cell_display = cell_style.display;
            if (false) {
                alert(`column_number=${column_number} cell_display=${cell_display}`);
            }
            /*
            if (cell_visibility != "hidden") {
                number_of_visible_columns++;
            } */
            if (cell_display != "none") {
                number_of_visible_columns++;
            }
        }
        return number_of_visible_columns;
    }

    public static get_backgroundColor_from_dataset_of_element(cell_element: HTMLTableCellElement): string {
        // RESTORE_CELL פונקציה זו באה לשרת את
        const background_color: string | undefined = cell_element.dataset.backgroundColor;
        if (background_color !== undefined) {
            return background_color;
        }
        else {
            // dataset זאת ברירת המחדל במידה ולא קיים צבע ב 
            return "white";
        }
    }

    public static get_color_from_dataset_of_element(cell_element: HTMLTableCellElement): string {
        // RESTORE_CELL פונקציה זו באה לשרת את
        const color: string | undefined = cell_element.dataset.color;
        if (color !== undefined) {
            return color;
        }
        else {
            // dataset זאת ברירת המחדל במידה ולא קיים צבע ב 
            return "black";
        }
    }
    public static PAINT_CELL(cell_element: HTMLTableCellElement, background_color: string, color: string): void {

        cell_element.style.backgroundColor = background_color;
        cell_element.style.color = color;
    }



    public static RESTORE_CELL(cell_element: HTMLTableCellElement): void {
        const background_color: string = TABLE_CELL_MARKER_UTILITIES.get_backgroundColor_from_dataset_of_element(cell_element);
        const color: string = TABLE_CELL_MARKER_UTILITIES.get_color_from_dataset_of_element(cell_element);
        cell_element.style.backgroundColor = background_color;
        cell_element.style.color = color;
    }

    public static PAINT_ROW(table_element: HTMLTableElement, row_number: number, background_color: string, color: string): void {
        //const number_of_columns: number = TABLE.trans_table_element_to_number_of_columns(table_element);
        const number_of_columns: number = TABLE_CELL_MARKER_UTILITIES.CALC_NUMBER_OF_COLUMNS_IN_ROW(table_element, row_number);
        for (let column_number = 0; column_number < number_of_columns; column_number++) {
            const cell_element: HTMLTableCellElement = TABLE.trans_table_element_and_row_number_and_column_number_to_cell_element(table_element, row_number, column_number);
            TABLE_CELL_MARKER_UTILITIES.PAINT_CELL(cell_element, background_color, color);
        }
    }

    public static RESTORE_ROW(table_element: HTMLTableElement, row_number: number): void {
        //const number_of_columns: number = TABLE.trans_table_element_to_number_of_columns(table_element);
        const number_of_columns: number = TABLE_CELL_MARKER_UTILITIES.CALC_NUMBER_OF_COLUMNS_IN_ROW(table_element, row_number);
        for (let column_number = 0; column_number < number_of_columns; column_number++) {
            const cell_element: HTMLTableCellElement = TABLE.trans_table_element_and_row_number_and_column_number_to_cell_element(table_element, row_number, column_number);
            TABLE_CELL_MARKER_UTILITIES.RESTORE_CELL(cell_element);
        }
    }

    public static PAINT_CELL_GIVEN_ROW_AND_COLUMN(table_element: HTMLTableElement, row_number: number, column_number: number, background_color: string, color: string): void {
        const cell_element: HTMLTableCellElement = TABLE.trans_table_element_and_row_number_and_column_number_to_cell_element(table_element, row_number, column_number);
        TABLE_CELL_MARKER_UTILITIES.PAINT_CELL(cell_element, background_color, color);
    }
}



//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

export class DOM_AUX_FUNCTIONS {
    public static show_or_hide_elements_by_class(p_class_name: string, p_visible: boolean): void {
        const collection_of_elements: HTMLCollectionOf<Element> = document.getElementsByClassName(p_class_name);
        for (let i = 0; i < collection_of_elements.length; i++) {
            const element = collection_of_elements[i] as HTMLElement;
            element.style.display = p_visible ? "" : "none";
        }
    }
}

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

export class SOUND_UTILS_USING_AUDIO_CONTEXT {

    // SOUND_UTIL_PLAY_AUDIO_FILE :נכון לתאריך 9.9.26 מחלקה זו עושה בעיות ואנחנו מנסים את העבודה עם המחלקה
    // SOUND_UTIL_PLAY_AUDIO_FILE :נכון לתאריך 9.9.26 מחלקה זו עושה בעיות ואנחנו מנסים את העבודה עם המחלקה
    // SOUND_UTIL_PLAY_AUDIO_FILE :נכון לתאריך 9.9.26 מחלקה זו עושה בעיות ואנחנו מנסים את העבודה עם המחלקה
    // SOUND_UTIL_PLAY_AUDIO_FILE :נכון לתאריך 9.9.26 מחלקה זו עושה בעיות ואנחנו מנסים את העבודה עם המחלקה

    // מופע יחיד של AudioContext לכל האפליקציה
    private static audioCtx: AudioContext | null = null;

    private static getAudioContext(): AudioContext | null {
        if (!SOUND_UTILS_USING_AUDIO_CONTEXT.audioCtx) {
            const AudioContextClass = window.AudioContext ||
                (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;

            if (AudioContextClass) {
                SOUND_UTILS_USING_AUDIO_CONTEXT.audioCtx = new AudioContextClass();
            }
        }
        return SOUND_UTILS_USING_AUDIO_CONTEXT.audioCtx;
    }

    public static async play_custom_sound(
        frequency: number = 800,
        durationInSeconds: number = 0.5,
        volume: number = 0.3,
        waveType: OscillatorType = 'sine'
    ): Promise<void> {
        const audioCtx = SOUND_UTILS_USING_AUDIO_CONTEXT.getAudioContext();

        if (!audioCtx) {
            console.log("AudioContext is not supported");
            return;
        }

        // במובייל חובה לחכות שהקונטקסט ייפתח בעקבות מחזור חיים של לחיצה
        if (audioCtx.state === 'suspended') {
            await audioCtx.resume();
        }

        const osc: OscillatorNode = audioCtx.createOscillator();
        const gain: GainNode = audioCtx.createGain();

        osc.type = waveType;
        osc.frequency.setValueAtTime(frequency, audioCtx.currentTime);

        const startTime: number = audioCtx.currentTime;
        const stopTime: number = startTime + durationInSeconds;

        gain.gain.setValueAtTime(volume, startTime);

        const fadeOutDuration: number = Math.min(0.05, durationInSeconds);
        const fadeOutStart: number = stopTime - fadeOutDuration;

        gain.gain.setValueAtTime(volume, fadeOutStart);
        gain.gain.exponentialRampToValueAtTime(0.00001, stopTime);

        osc.connect(gain);
        gain.connect(audioCtx.destination);

        osc.start(startTime);
        osc.stop(stopTime);

        // ניקוי זיכרון בסיום השמעת הצליל
        osc.onended = () => {
            osc.disconnect();
            gain.disconnect();
        };
    }



    public static play_button_click_notification(): void {
        this.play_custom_sound(1046, 0.03, 0.2, 'sine');
    }


    public static async play_whatsapp_notification(): Promise<void> {
        this.play_custom_sound(520, 0.08, 0.2, 'sine');
        await UTL.sleep_async(70);
        this.play_custom_sound(780, 0.25, 0.3, 'sine');
    }


    public static async play_correct_answer_notification(): Promise<void> {
        this.play_custom_sound(659, 0.1, 0.3, 'sine');
        await UTL.sleep_async(100);
        this.play_custom_sound(1046, 0.4, 0.3, 'sine');
    }

    public static play_wrong_anser_notification(): void {
        this.play_custom_sound(98, 0.6, 0.25, 'sawtooth');
    }
}

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

export class SOUND_UTIL_PLAY_AUDIO_FILE {
    public static readonly beep1: HTMLAudioElement = new Audio('/sounds/beep1.wav');// copy of Windows Navigation Start
    public static readonly beep2: HTMLAudioElement = new Audio('/sounds/beep2.wav');// copy of Windows Navigation Start
    public static readonly beep3: HTMLAudioElement = new Audio('/sounds/beep3.wav');// copy of Windows Navigation Start
    public static readonly temp: HTMLAudioElement = new Audio('/sounds/temp.wav');// copy of Windows Navigation Start

    public static readonly Alarm01: HTMLAudioElement = new Audio('/sounds/Alarm01.wav');
    public static readonly notification_pop: HTMLAudioElement = new Audio('/sounds/notification_pop.wav');



    public static play(audioElement: HTMLAudioElement): void {
        audioElement.currentTime = 0; // החזרה להתחלה לניגון מיידי
        audioElement.play().catch((err: Error) => {
            console.log("Playback failed or blocked:", err);
        });
    }

}

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

export class DOM_VISUAL_EFFECTS {
    public static async PERFORM_BLINK_ELEMENT_V1(element: HTMLElement, blink_count: number = 2, visible_duration: number = 500, hidden_duration: number = 200): Promise<void> {
        // שים לב יש להשתמש ב
        // (1) element.style.visibility = "visible";
        // (2) element.style.visibility = "hidden";
        // מחרוזת מלאה או מחרוזת ריקה לסירוגין element.innerText ולא לשים
        // אז המקום על המסך יכול להשתנות element.innerText מה ההבדל? ההבדל הוא שאם משנים את
        // האם זה קרה? כן קרה לנו. פשוט האלמנט הופיע ונעלם כי לא הכיל כלום
        // element.style.visibility אז איך פותרים את זה? הפתרון הוא כאמור להשתמש ב

        const original_color: string = element.style.color;
        for (let i: number = 0; i < blink_count; i++) {
            element.style.color = original_color;
            await UTL.sleep_async(visible_duration);
            element.style.color = "transparent";
            await UTL.sleep_async(hidden_duration);
        }
        element.style.color = original_color;
    }
}

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

export class ARRAY_UTILITIES {

    public static get_array_of_sequential_numbers(p_length: number, p_start_number: number = 0): number[] {
        // תפקיד הפונקציה ליצור מערך של מספרים עוקבים
        // תפקיד הפונקציה ליצור מערך של מספרים עוקבים
        // תפקיד הפונקציה ליצור מערך של מספרים עוקבים
        const temp: number[] = [];
        for (let i: number = 0; i < p_length; i++) {
            const num: number = p_start_number + i;
            temp.push(num);
        }
        return temp;
    }


    public static get_array_of_sequential_numbers_start_from_zero(p_length: number): number[] {
        // for example: length = 5 >>>> [0, 1, 2, 3, 4]
        // for example: length = 5 >>>> [0, 1, 2, 3, 4]
        // for example: length = 5 >>>> [0, 1, 2, 3, 4]
        const start_number = 0;
        const result_arr = ARRAY_UTILITIES.get_array_of_sequential_numbers(p_length, start_number);
        return result_arr;
    }

    public static get_array_of_sequential_numbers_start_from_one(p_length: number): number[] {
        // for example: length = 5 >>>> [1, 2, 3, 4, 5]
        // for example: length = 5 >>>> [1, 2, 3, 4, 5]
        // for example: length = 5 >>>> [1, 2, 3, 4, 5]
        const start_number = 1;
        const result_arr = ARRAY_UTILITIES.get_array_of_sequential_numbers(p_length, start_number);
        return result_arr;
    }

    public static swap_elements_in_array_of_numbers(array: number[], index_1: number, index_2: number): void {
        // פונקציה זו תפקידה להחליף 2 איברים במערך
        // פונקציה זו תפקידה להחליף 2 איברים במערך
        // פונקציה זו תפקידה להחליף 2 איברים במערך
        const temp: number = array[index_1];
        array[index_1] = array[index_2];
        array[index_2] = temp;
    }

    public static get_clone_of_array_of_numbers_with_two_elements_swapped(array_of_numbers: number[], index_1: number, index_2: number): number[] {
        // פונקציה זו תפקידה לייצר העתק של המערך ולהחליף בו 2 איברים
        const clone_array: number[] = [...array_of_numbers];
        ARRAY_UTILITIES.swap_elements_in_array_of_numbers(clone_array, index_1, index_2);
        return clone_array;
    }

    public static array_of_numbers_contains_number(p_array_of_numbers: number[], p_number: number): boolean {
        // באותו שם פונקציה UTL אנחנו משתמשים בפונקציה שקיימת לנו ב 
        const bval = UTL.array_of_numbers_contains_number(p_array_of_numbers, p_number);
        return bval;
    }


}

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

// random has move to a seperate file


//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

// svg has move to a seperate file

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

export class DOMRect_UTILITIES {
    public static GetMx(rect: DOMRect): number {
        if (!(rect instanceof DOMRect)) {
            alert("Error: Invalid DOMRect passed to GetMx");
            return 0;
        }
        return rect.left + rect.width / 2;
    }

    public static GetMy(rect: DOMRect): number {
        if (!(rect instanceof DOMRect)) {
            alert("Error: Invalid DOMRect passed to GetMy");
            return 0;
        }
        return rect.top + rect.height / 2;
    }
}

//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------

export class PROGRAMMATICALLY_CREATED_ELEMENTS {

    public static CREATE_CENTERED_ELEMENT(
        p_parent_element: HTMLElement,
        p_id: string,
        p_text: string,
        p_fg: string,
        p_bg: string,
        p_font_size: string
    ): HTMLElement {
        const element: HTMLElement = window.document.createElement("div");

        element.id = p_id;
        element.innerText = p_text;

        element.style.color = p_fg;
        element.style.backgroundColor = p_bg;
        element.style.fontSize = p_font_size;
        element.style.fontWeight = "bold";
        element.style.textAlign = "center";

        element.style.position = "absolute";
        element.style.left = "50%";
        element.style.top = "50%";
        element.style.transform = "translate(-50%, -50%)";

        element.style.display = "none";

        p_parent_element.appendChild(element);

        return element;
    }


    public static CREATE_CENTERED_WAIT_ELEMENT(
        p_parent_element: HTMLElement,
        p_id: string,
        p_text: string,
        p_fg: string,
        p_bg: string,
        p_font_size: string
    ): HTMLElement {
        const wait_element: HTMLElement =
            PROGRAMMATICALLY_CREATED_ELEMENTS.CREATE_CENTERED_ELEMENT(
                p_parent_element,
                p_id,
                p_text,
                p_fg,
                p_bg,
                p_font_size
            );

        return wait_element;
    }
}
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------



